import moment from "moment";
import {
  axiosInstance as axios,
  axiosInstance,
} from "../../redux/constants/axiosInstance";
import {
  ACTIVATE_QUOTE,
  ACTIVE_STATUS,
  ADD_CHECKLIST,
  ADD_COLOR_CODE,
  ADD_COMM,
  ADD_COMPANY,
  ADD_COMPANY_DETAILS,
  ADD_CONTACTS,
  ADD_DOCUMENT_PROJECT,
  ADD_DOC_TO_CLIENT,
  ADD_DOC_TO_CONTACT,
  ADD_DOC_TO_SUPPLIER,
  ADD_DOC_TO_USER,
  ADD_INVOICES,
  ADD_ITEM_IN_EXISTING_ORDER,
  ADD_JOB_TPYE,
  ADD_PRODUCT_PART,
  ADD_PURCHASING_ORDER,
  ADD_QUOTES,
  ADD_SECTION,
  ADD_STOCK_COLOR_CODE,
  ADD_SUBSECTION,
  ADD_SUPPLIER,
  ADD_TAGS_CONTACT,
  ADD_TASK,
  ADD_TASK_TO_TEAM,
  ADD_TO_WAREHOUSE,
  ADD_UPDATE_FINANCIAL_BY_PROJECT,
  ADVICED_ITEM_PURCHASE,
  ADVICED_PURCHASE_ORDER_LIST,
  API_URL,
  APPROVE_QUOTES,
  BOOKKEEPING_PROPS,
  CHANGE_PROJECT_TAB,
  // BOOKKEEPING_PROPS,
  CHANGE_STATUS,
  CHAT_API_URL,
  CHECK_IF_TIME_SESSION,
  CLEAR_USER_UPDATE,
  CREATE_DUPLICATE_QUOTES,
  CREATE_NEW_TIME_SESSION,
  CREATE_ORDER_PICKING,
  CREATE_PROJECT,
  CREATE_UNLINK,
  DEACTIVATED_QUOTE,
  DELETE_CHECKLIST,
  DELETE_COLOR,
  DELETE_Contacts,
  DELETE_DOCS,
  DELETE_DOCUMENET,
  DELETE_JOB_TYPES,
  DELETE_PRODUCT,
  DELETE_PRODUCT_DOCUMENT,
  DELETE_ASSETS_DOCUMENT,
  DELETE_PRODUCT_PART_STOCK,
  DELETE_SECTION,
  DELETE_STOCK_COLOR,
  DELETE_SUBSECTION,
  DELETE_TAGS,
  DELETE_TASK,
  DELETE_TASK_ID_FROM_TIMER,
  DELETE_UPDATE_QUOTE_STATE,
  DUPLICATE_SECTION,
  EMAIL_EXIST_OR_NOT,
  EMPTY_PRODUCT_PART,
  FATCH_CONTACT_ID,
  FATCH_ROLEMODULE_ACCESS,
  FATCH_USER_BY_COMPANY_ID,
  FETCH_ACTIVE_USER,
  FETCH_ADD_PROJECT_ID,
  FETCH_CLIENT,
  FETCH_COMPANY,
  FETCH_CONTACTSCLIENT_BYID,
  FETCH_CONTACT_BYID,
  FETCH_CREATETRANSLATION,
  FETCH_DOCSCLIENT_BYID,
  FETCH_DOCSCONTACT_BYID,
  FETCH_DOCSUPPLIER_BYID,
  FETCH_DOCUMENT_BY_ID,
  FETCH_DOCUMENT_BY_PRODUCT_PART_ID,
  FETCH_DOCUMENT_BY_ASSETS_ID,
  FETCH_DOCUMENT_PROJECT,
  FETCH_FINANCIAL_BY_PROJECT,
  FETCH_INVOICES,
  FETCH_INVOICE_BY_ID,
  FETCH_JOB_TYPES,
  FETCH_LANGUAGES,
  FETCH_LAST_QUOTE_CODE,
  FETCH_LINK,
  FETCH_LINKCLIENT_BYID,
  FETCH_MANAGERS_LIST,
  FETCH_MYFACEBOOK,
  FETCH_PO_BY_PROJECT,
  FETCH_PO_ORDER_CODE,
  FETCH_PRODUCT,
  FETCH_PRODUCT_BY_SUPPLIER_ID,
  FETCH_PRODUCT_DROPDOWN,
  FETCH_PRODUCT_PART,
  FETCH_PROJECT,
  FETCH_PROJECTS,
  FETCH_PROJECTS_DROPDOWN,
  FETCH_PROJECT_CLIENT,
  FETCH_PROJECT_BY_COMPANY,
  FETCH_PROJECT_BY_ID,
  FETCH_PROJECT_KAN_BAN,
  FETCH_PROJECT_WEEKLY,
  FETCH_PURCHASING_ORDER,
  FETCH_PURCHASING_ORDER_AWAITING,
  FETCH_QUOTES,
  FETCH_QUOTES_BY_COMPANY_ID,
  FETCH_ROLE_MODULE,
  FETCH_SCREEN,
  FETCH_SEARCH_CLIENTS,
  FETCH_SEARCH_SUPPLIER,
  FETCH_SUPPLIERS,
  FETCH_SUPPLIERS_LIST,
  FETCH_SUPPLIERS_PRODUCT,
  FETCH_SUPPLIER_BYID,
  FETCH_TAGS_CONTACT,
  FETCH_TASKS_BY_COMPANY_ID,
  FETCH_TASK_BY_CONTACT_ID,
  FETCH_TASK_BY_ID,
  FETCH_TASK_BY_PROJECT,
  FETCH_TEAMS,
  FETCH_TEAM_PROJECTWISE,
  FETCH_TRANSLATION,
  FETCH_USER_BY_COMPANY,
  FETCH_USER_BY_ID,
  FETCH_USER_NOTIFICATION,
  FETCH_WAREHOUSE_PURCHASING_ORDER,
  FETCH_WEEKLY,
  FORGOT_PASS,
  GET_ACTIVE_TIME_SESSION,
  GET_QUOTE_SECTIONS,
  GET_TIME_SESSION,
  GET_USER_TIME_SESSION,
  IS_CURRENTCOMPANY,
  JIT_ADVICED_ITEM_PURCHASE,
  JIT_PURCHASE_ORDER_LIST,
  OPEN_TIMER_FROM_HEADER,
  PRODUCT_PART_CODE_EMAIL_EXIST_OR_NOT,
  PROJECT_GROUPING,
  REMOVE_DOCSCLIENT_BYID,
  // REMOVE_DOCSCLIENT_BYID,
  SEND_EMAIL,
  SEND_EMAIL_FOR_PURCHASING_ORDER,
  SET_EQUIPMENTS_DETAIL,
  SET_INVOICE_STATUS_TO_FALSE,
  SET_STATUS_TO_FALSE,
  SET_TIME_SESSION_TO_FALSE,
  STOP_TIMER_FROM_HEADER,
  SUB_DOMAIN_NAME,
  TASK_FOR_A_WEEK,
  TASK_GROUPING,
  TASK_TODAY,
  TOTAL_STOCK_AVAILABLE,
  UPDATE_CALENDAR_DATA,
  UPDATE_COMPANY,
  UPDATE_CONTACTS,
  UPDATE_INVOICE,
  UPDATE_JOB_TPYE,
  UPDATE_ORDER_PRODUCT_QTY,
  UPDATE_PO_TASK_STATUS,
  UPDATE_PRODUCT_DROPDOWN,
  UPDATE_PRODUCT_PART,
  UPDATE_PRODUCT_PART_STOCK,
  UPDATE_PROJECT_BY_ID,
  UPDATE_PROJECT_COVER,
  UPDATE_QUOTE_SECTIONS,
  UPDATE_SUPPLIER,
  UPDATE_TASK,
  UPDATE_TASK_STATUS,
  UPDATE_TIME_SESSION,
  UPDATE_TRANSLATION_DATA,
  UPLOAD_TO,
  USER_CREATE,
  USER_LOGIN,
  USER_LOGOUT,
  USER_UPDATE,
  USER_VERIFY,
  GET_PO_LIST,
  APPROVE_PO,
  FETCH_INVOICE_ALL_LIST,
  FETCH_PRODUCT_PART_LIST,
  ADD_INVOICE_PROJECT,
  UPDATE_INVOICE_PROJECT,
  FETCH_PAYMENT_DEADLINE,
  FETCH_INVOICE_BY_INVOICE_ID,
  FETCH_PROJECT_BY_CLIENT,
  FETCH_PRODUCTS_BY_QUOTES,
  INVOICE_DELETE,
  // FETCH_CREDIT_INVOICE_ALL_LIST,
  FETCH_LAST_INVOICE_CODE,
  FETCH_INVOICE_SETTING_LIST,
  FETCH_MEMBERS,
  FETCH_TEAM_MEMBERS,
  ADD_TEAM,
  DELETE_TEAM,
  FETCH_TEAM,
  DELETE_TEAM_MEMBER,
  UPDATE_TEAM,
  ADD_INVOICE_SETTING,
  FETCH_INVOICE_SETTING_BY_ID,
  FETCH_ORDER_PICKING_LIST,
  ADD_ORDER_PICKING,
  FETCH_PROJECT_BB,
  FETCH_STOCK_ITEM_LIST,
  ADD_TO_COUNT_STOCK,
  FETCH_COUNT_STOCK_REPORT,
  DELETE_COUNT_STOCK,
  UPDATE_COUNT_STOCK,
  UPDATE_CHECK_COUNT_STOCK,
  QUOTE_EXTRAWORK_VALIDATION,
  FETCH_EQUIPMENT_BY_WEEK,
  ADD_EQUIPMENT_TO_TASK,
  FETCH_ASSET_LIST,
  ADD_ASSETS,
  FETCH_PARTS_LIST,
  FETCH_PRODUCTION_HISTORY,
  FETCH_PROVISIONAL,
  FETCH_GROUP_LIST,
  ASSET_TYPES,
  DELETE_ASSET,
  FETCH_PARTICULAR_ASSET,
  DELETE_GROUP,
  FETCH_EQUIPMENTPARTLIST,
  FETCH_CLIENT_LIST,
  FETCH_EQUIPMENT_LIST,
  FETCH_CATEGORY_LIST,
  FETCH_FACILITY_LIST,
  UPDATE_SUPPLIER_CONTACT_POSITION,
  ADD_CREDIT_NOTE,
  IS_ACTIVE_WIDGET,
  ACTIVE_WORKER,
  TOP_PROJECT,
  FETCH_INVENTORY,
  WEEK_PROJECTS,
  PROJECT_COUNT,
  FETCH_PURCHASING_ASSET_LIST,
  UPDATE_ASSETS,
  FETCH_LAST_PURCHASING_ORDER_CODE_ASSET_LIST,
  FETCH_ASSET_EQUIPMENT_LIST,
  ADD_ASSET_PURCHASING_ORDER,
  DELETE_PO_ASSET,
  CHANGE_PO_STATUS,
  FETCH_INSTRUCTIONS_LIST,
  FETCH_MAINTENANCE_LIST,
  FETCH_ASSET_TREE_LIST,
  TURN_UNAVAILABLE,
  LAST_365_INVOICE_INSIGHTS,
  MODAL_LIST,
  PRODUCT_AND_PART_VALIDATION,
  FETCH_TEAMS_LIST,
  GLOBAL_REQUEST,
  FETCH_EQUIPMENT_TASK_LIST,
  FETCH_ACTIVE_USER_LIST,
  INVOICE_SEND_EMAIL,
  INVOICE_SEND_EMAIL_COUNT,
  FETCH_LAST_CREDIT_INVOICE_CODE,
  INVOICE_GENRATE_PDF,
  FETCH_TASK_WITHOUT_PROJECT,
  UPDATE_WAREHOUSE_ORDER_PROJECT,
  FETCH_PRODUCT_PART_CATEGORIES,
  FETCH_ASSET_PURCHASING_ORDER_BY_ID,
  FETCH_PRODUCT_STOCK_FILTER_LIST,
  FETCH_TODAYONBOARDDETAILS,
  SEND_INVOICE_EMAIL,
  SEND_INVOICE_EMAIL_COUNT,
  USER_VERIFICATION,
  UPDATE_SYNC_QB_STATUS,
  PROJECT_COST_DETAILS,
  TASK_MODAL_COMMENT_DELETE,
  ADD_BILLING_INFORMATION,
  UPDATE_BILLING_INFORMATION,
  FETCH_BILLING_INFORMATION,
  FETCH_INDUSTRY,
  ADD_INDUSTRY_TO_COMPANY,
  SEND_APPROVED_QUOTES_EMAIL,
  OCR_PROCESSED_DOCUMENT,
  OCR_DOCUMENT_SAVED,
  OCR_FETCH_ALL_DOCUMENTS,
  OCR_DOCUMENT_BY_ID,
  PO_SUPPLIER_PROPS_API,
  ADD_FORM,
  ADD_FORM_SECTION,
  FETCH_CLIENTS_BY_COMPANY,

  //
  FETCH_FORM_LIST,
  FETCH_WORKFLOW_FORM_LIST,
  FETCH_FORM_BY_ID,
  FETCH_TEMPLATE_FORMS,
  DELETE_FORM,
  UPDATE_FORM,
  ADD_PERSONAL_TASK,
  FETCH_PERSONAL_TASK,
  OCR_DOCUMENT_ACCEPT,
  OCR_DOCUMENT_DUPLICATE,
  OCR_DOCUMENT_DELETE,
  FETCH_INTERGRATION,
  UPDATE_ISCHECK_PERSONAL_TASK,
  AZURE_AUTH_TOKEN,
  TEMPLATE_TYPES,
  TEMPLATE_BUILDER_AVAILABLE_FIELDS,
  AVAILABLE_TEMPLATES,

  //
  FETCH_FORM_BY_PROJECT,
  LINK_FORM_BY_PROJECT,
  UNLINK_FORM_BY_PROJECT,
  LINK_TASK_BY_FORM,
  FETCH_USER_MAX_AMOUNT,
  UPDATE_USER_MAX_AMOUNT,
  APPROVED_ORDER,
  FETCH_PROJECT_BILLING_TERMS,
  ADD_NEW_CLIENT,
  UPDATE_CLIENT_COMPANY,
  UPDATE_CLIENT_DETAILS,
  FETCH_CLIENT_BY_ID,
  EXISTING_COMPANY_ADDRESS,
  DELETE_MULTIPLE_ADDRESS,
  FETCH_CLIENT_CONTACTS_BY_CLIENT_ID,
  FETCH_CLIENT_TASKS,
  CLIENT_ACTIVITY_TIMELINE,
  GET_CREDIT_TYPE_DROPDOWN,
  GET_INVOICE_TYPE_DROPDOWN,
  GET_DISCOUNT_TYPE_DROPDOWN,
  ADD_DISCOUNT,
  DELETE_CLIENT_CONTACT,
  FETCH_ID_TYPE,
  FETCH_EMPLOYEETYPE,
  FETCH_CONTRACT_TYPE,
  FETCH_COMPANY_CAR,
  FETCH_REASONS,
  FETCH_USER_CERTIFICATION,
  INSERT_DOC_TO_S3,
  SEND_EMAIL_REGISTRATION,
  UPDATE_DELETE_COMPANY_CAR,
  UPDATE_DELETE_CONTRACT_TYPE,
  UPDATE_DELETE_EMPLOYEE_TYPE,
  UPDATE_DELETE_ID_TYPE,
  UPDATE_DELETE_REASONS,
  DELETE_COMPANY_CAR,
  DELETE_CONTRACT_TYPE,
  DELETE_EMPLOYEE_TYPE,
  DELETE_ID_TYPE,
  DELETE_REASONS,
  ADD_FORM_RESPONSE,
  QUOTE_GENRATE_PDF,
  //
  FETCH_PAYROLLHISTORY,
  FETCH_NOT_ENROLLED_PAYROLL,
  FETCH_PROJECT_WORKS,
  DELETE_WORK_LIST,
  ADD_WORK_TASK,
  DELETE_WORK_TASK,
  FETCH_WORK_TASK_BY_ID,
  UPDATE_WORK_TASK,
  PROJECT_HIRING_LIST,
  PROJECT_HIRE_CREATE,
  PROJECT_HIRE_UPDATE,
  PROJECT_HIRE_DELETE,
  FETCH_USER_SCHEDULE,
  UPDATE_USER_LOG_TIMER,
  UPDATE_USER_TIME_OFF,
  UPDATE_PROJECT_HIRING_STATUS,
  UPDATE_PROJECT_HIRING_EXTEND_PERIOD,
  PROJECT_RENT_DELETE,
  UPDATE_PROJECT_RENT_STATUS,
  UPDATE_PROJECT_RENT_EXTEND_PERIOD,
  ADD_PHASE_MATERIALS,
  FETCH_PHASE_MATERIALS_BY_PROJECT,
  FETCH_PHASE_MATERIALS_BY_ID,
  DELETE_PHASE,
  DELETE_MATERIALS,
  ADD_MATERIAL_LIST,
  FETCH_MATERIALS_LIST,
  UPDATE_MATERIALS_QUANTITY,
  FETCH_ORDER_PICKING_PRODUCT,
  ADD_RETURN_TO_WAREHOUSE,
  UPDATE_TASK_IMAGE,
  FETCH_USER_TITLE,
  ADD_UPDATE_USER_TITLE,
  DELETE_USER_TITLE,
  FETCH_PROJECTS_BY_WEEKS,
  SINGLE_UPLOAD_TO_S3,
  MULTIPLE_UPLOAD_TO_S3,
  DOWNLOAD_DOCUMENT,
  STORE_TIMER_SCREEN_SHOTS,
  TIME_MANAGEMENT_SESSION_TIMELINE,
  DELETE_SCREENSHOTS,
  TIME_MANAGEMENT_DAILY_SUMMARY,
  ADD_TRANSLATION_DATA,
  ADD_NEW_PROJECT_BILLING,
  DELETE_NEW_PROJECT_BILLING,
  DELETE_USER_TIME_OFF,
  FECTH_UNITS_PRODUCTS,
  MAKING_TEMPLATE_DEFAULT,
  FETCH_ISDEFAULT_TEMPLATE,
  FILES_INSERT_DOC_TO_S3,
  ADD_DOCUMENT_TO_TASK,
  ADD_TASK_FORM,
  UPDATE_TASK_FORM,
  DELETE_TASK_FORM,
  FETCH_TASK_FORM,
  DELETE_BOM_ITEM,
  DELETE_SUB_SECTION_PARTS,
  DRIVE_ADD_FOLDER,
  FETCH_ZERO_PARENTS_FOLDER,
  FETCH_SPIRE_FOLDER_DOCUMENTS,
  DELETE_DRIVE_FOLDER_OR_FILE,
  ADD_DOC_ROOT,
  DRIVE_UPDATE_FOLDER,
  FILE_CHUNK_START,
  FILE_PRESIGN,
  FILE_CHUNK_COMPLETE,
  FILE_CHUNK_ABORT,
  FETCH_FORM_CERTIFICATES,
  AJIT_SPIRE_API_JSON,
  COWORKER_CERTIFICATIONS_ADD_UPDTE_DELETE,
  FETCH_TODO_LIST,
  UPDATE_TASK_PRIORITY,
  UPDATE_TASK_ASSIGNEE,
  UPDATE_TASK_INDEX,
  UPDATE_CHECKLIST_DATA,
  DELETE_PROJECT,
  ADD_TASK_DESCRIPTION,
  FETCH_BRAND_HEALTH_APPLICATION,
  SUPPLIER_EMAIL_EXIST_OR_NOT,
  CLIENT_NAME_EXIST_OR_NOT,
  REMOVE_TASK_ASSIGNEE,
  SET_ASSIGNEE_LOCAL_DATA,
  PRODUCT_CATALOGUE_API,
  FETCH_AUTO_PRODUCT_PART_ITEM_ID,
  DUPLICATE_TEMPLATE,
  FETCH_TODO_LIST_BY_PROJECT,
  ADD_DOCUMENT_TO_ORDER,
  FETCH_DOCUMENT_BY_ORDERID,
  FETCH_PRODUCT_WITHOUT_SUPPLIER,
  ADD_SUPPLIER_TO_PRODUCT,
  SUPPLIER_CODE_EXIST_OR_NOT,
  SUPPLIER_BAR_CODE,
  SUPPLIER_BAR_CODE_SCAN,
  SEND_PO_EMAIL_TO_SUPPLIER,
  PART_DUPLICATE,
  UPDATE_PRODUCT_DESCRIPTION,
  ADD_TASK_ACTIVITY,
  UPDATE_TASK_ACTIVITY,
  SEARCH_ACTIVITY,
  FETCH_ACTIVITY,
  DELETE_ACTIVITY,
  TIMER_FOR_ACTIVITY,
  GET_TIMER_FOR_ACTIVITY,
  FETCH_PROJECT_EQUIPMENT_ACTIVITY,
  SEARCH_AI_FOLDER_FILE,
  UPDATE_USER_FILTER,
  ADD_PARTS_EQUIPMENTS,
  FETCH_PARTS_EQUIPMENTS,
  UPDATE_PARTS_EQUIPMENTS,
  DELETE_PARTS_EQUIPMENTS,
  UPDATE_TASK_ESTIMATIONS,
  BUILD_PO_DATA,
  DELETE_RESOURCE_PO,
  LOGOUT_SESSION,
  FETCH_TASK_HISTORY,
  FETCH_TASK_TIMESHEET,
  ADD_UPDATE_TASK_DEPENDENCIES,
  DELETE_DEPENDENCIES,
  ADD_TASK_PRODUCTS_PART,
  UPDATE_TASK_PRODUCTS_PART,
  FETCH_TASK_PRODUCTS_PART,
  DELETE_TASK_PRODUCTS_PART,
  FETCH_TASK_COST_DETAILS,
  CREATE_TASK_INVOICE,
  UPDATE_SECTION_DEFAULT,
  DELETE_COMPOSE_PRODUCT,
  UPDATE_TASK_PRODUCT_PART_QTY,
} from "../constants/type";

export const UpdateJobtypes = (jobid, jobtypename) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/UpdateJobtypes`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      jobid,
      jobtypename,
    },
  })
    .then((response) => {
      dispatch({
        type: UPDATE_JOB_TPYE,
        data: response.data,
      });
      return Promise.resolve([]);
    })
    .then(() => dispatch(FetchJobtypes()));
};
export const AddJobtypes =
  (userid, jobtypename, jobtypedescription) => async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/User/AddJobtypes`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        userid,
        jobtypename,
        jobtypedescription,
      },
    })
      .then((response) => {
        dispatch({
          type: ADD_JOB_TPYE,
          data: response.data,
        });
        return Promise.resolve([]);
      })
      .then(() => dispatch(FetchJobtypes()));
  };
export const FetchJobtypes = () => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/FetchJobtypes`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {},
  }).then((response) => {
    dispatch({
      type: FETCH_JOB_TYPES,
      data: response,
    });
    return Promise.resolve([]);
  });
};
export const DeleteJobtypes = (jobid) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/DeleteJobtypes`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      jobid,
    },
  })
    .then((response) => {
      dispatch({
        type: DELETE_JOB_TYPES,
        data: response,
      });
      return Promise.resolve([]);
    })
    .then(() => dispatch(FetchJobtypes()));
};
export const DeleteContacts = (contactid) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/DeleteContact`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      contactid: contactid,
    },
  }).then((response) => {
    dispatch({
      type: DELETE_Contacts,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};
export const CreateUnlinkContact = (contactid) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/CreateUnlinkContact`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      contactid: contactid,
    },
  }).then((response) => {
    dispatch({
      type: CREATE_UNLINK,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const FetchUsersByCompany =
  (companyid, pagerequire, pagenumber) => async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchUsersByCompany`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        companyid,
        pagerequire: pagerequire,
        pagenumber: pagenumber,
      },
    }).then((response) => {
      dispatch({
        type: FATCH_USER_BY_COMPANY_ID,
        data: response,
      });
      return Promise.resolve([]);
    });
  };

export const FetchUsersSchedule = (weekNumber) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/FetchUsersSchedule`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      weekNumber,
      type: weekNumber % 2 === 0 ? "even" : "odd",
    },
  }).then((response) => {
    dispatch({
      type: FETCH_USER_SCHEDULE,
      data: response,
    });
    return Promise.resolve([]);
  });
};

export const UpdateUsersLogTimer = (payload) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/UpdateUsersLogTimer`,
    headers: {
      "Content-Type": "application/json",
    },
    data: payload,
  }).then((response) => {
    dispatch({
      type: UPDATE_USER_LOG_TIMER,
      data: response,
    });
    return Promise.resolve([]);
  });
};

export const UpdateUsersTimerOff = (payload) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/UpdateUsersTimeOff`,
    headers: {
      "Content-Type": "application/json",
    },
    data: payload,
  }).then((response) => {
    dispatch({
      type: UPDATE_USER_TIME_OFF,
      data: response,
    });
    return Promise.resolve([]);
  });
};

export const FetchContactsByCompanyid =
  (companyid, pagenumber, filter, recordsPerPage, priority) =>
  async (dispatch) => {
    await axios({
      method: "post",
      url: `${CHAT_API_URL}/api/User/FetchContactsByCompanyid`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        companyid: companyid,
        pagenumber: pagenumber,
        filter: filter,
        recordsPerPage: recordsPerPage,
        priority: priority,
      },
    }).then((response) => {
      dispatch({
        type: FATCH_CONTACT_ID,
        data: response,
      });
      return Promise.resolve([]);
    });
  };

export const FetchsupplierData =
  (pagenumber, pagerequire, orderby, type, filter) => async (dispatch) => {
    await axios({
      method: "post",
      url: `${CHAT_API_URL}/api/User/FetchSupplierList`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        pagenumber: pagenumber,
        querystring: filter,
        pagerequire: pagerequire,
        orderby: orderby,
        type: type,
      },
    }).then((response) => {
      dispatch({
        type: FETCH_SUPPLIERS_LIST,
        data: response,
      });
      return Promise.resolve([]);
    });
  };

export const Fetchsuppliers = () => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/Fetchsuppliers`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {},
  }).then((response) => {
    dispatch({
      type: FETCH_SUPPLIERS,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const AddTagsContact = (userid, tagname) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/AddTags`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      userid: userid,
      tagname: tagname,
    },
  }).then((response) => {
    dispatch({
      type: ADD_TAGS_CONTACT,
      data: response,
    });
    return Promise.resolve([]);
  });
};
export const FetchAddTagsContact = (querystring) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/FetchTags`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      querystring: querystring,
    },
  }).then((response) => {
    dispatch({
      type: FETCH_TAGS_CONTACT,
      data: response,
    });
    return Promise.resolve([]);
  });
};
export const FetchCompany = () => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/Company/FetchCompany`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {},
  }).then((response) => {
    dispatch({
      type: FETCH_COMPANY,
      data: response,
    });
    return Promise.resolve([]);
  });
};
export const fetchLanguages = () => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/FetchLanguages`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {},
  }).then((response) => {
    dispatch({
      type: FETCH_LANGUAGES,
      data: response,
    });
    return Promise.resolve([]);
  });
};
export const fetchTranslationData =
  (language, screenname, companyid) => async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchTranslationData`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        language: language,
        screenname: screenname,
        companyid: companyid || window.localStorage.getItem("companyid"),
      },
    }).then((response) => {
      dispatch({
        type: FETCH_TRANSLATION,
        data: response,
      });
      return Promise.resolve([]);
    });
  };
export const createTranslation =
  (userid, language, isocode) => async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/User/CreateTranslation`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        userid: userid,
        language: language,
        isocode: isocode,
      },
    }).then((response) => {
      dispatch({
        type: FETCH_CREATETRANSLATION,
        data: response,
      });
      return Promise.resolve([]);
    });
  };
export const updateTranslationData =
  (language, screenname, fieldtranslations) => async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/User/UpdateTranslationData`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        language: language,
        screenname: screenname,
        fieldtranslations: fieldtranslations,
      },
    }).then((response) => {
      dispatch({
        type: UPDATE_TRANSLATION_DATA,
        data: response,
      });
      return Promise.resolve([]);
    });
  };
export const FetchScreenname = (moduleid) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/FetchScreenname`,
    headers: {
      "Content-Type": "application/json",
    },
    data: { moduleid: moduleid },
  }).then((response) => {
    dispatch({
      type: FETCH_SCREEN,
      data: response,
    });
    return Promise.resolve([]);
  });
};
export const FetchManagersList = () => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/FetchManagers`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {},
  }).then((response) => {
    dispatch({
      type: FETCH_MANAGERS_LIST,
      data: response,
    });
    return Promise.resolve([]);
  });
};
export const FetchContactById = (contactid) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/FetchContactById`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      contactid: contactid,
    },
  }).then((response) => {
    dispatch({
      type: FETCH_CONTACT_BYID,
      data: response,
    });
    return Promise.resolve([]);
  });
};
export const FetchSuppliertById = (supplierid) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/fetchSupplierById`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      supplierid: supplierid,
    },
  }).then((response) => {
    dispatch({
      type: FETCH_SUPPLIER_BYID,
      data: response,
    });
    return Promise.resolve([]);
  });
};
export const FetchSearchClients = (querystring) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/SearchClient`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      querystring: querystring,
    },
  }).then((response) => {
    dispatch({
      type: FETCH_SEARCH_CLIENTS,
      data: response,
    });
    return Promise.resolve([]);
  });
};

export const FetchSearchSupplier = (querystring) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/SearchSupplier`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      querystring: querystring,
    },
  }).then((response) => {
    dispatch({
      type: FETCH_SEARCH_SUPPLIER,
      data: response,
    });
    return Promise.resolve([]);
  });
};
export const FetchDocsContactById = (contactid) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/Files/FetchDocsContactsByid`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      contactid: contactid,
    },
  }).then((response) => {
    dispatch({
      type: FETCH_DOCSCONTACT_BYID,
      data: response,
    });
    return Promise.resolve([]);
  });
};
export const FetchDocsSupplierById = (supplierid) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/Files/Fetchdocumentbysupplierid`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      supplierid: supplierid,
    },
  }).then((response) => {
    dispatch({
      type: FETCH_DOCSUPPLIER_BYID,
      data: response,
    });
    return Promise.resolve([]);
  });
};

export const RemoveDocsClientById = () => (dispatch) => {
  dispatch({
    type: REMOVE_DOCSCLIENT_BYID,
    data: [],
  });
};
export const FetchDocsClientById = (clientid) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/Files/FetchDocsClientByid`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      clientid: clientid,
    },
  }).then((response) => {
    dispatch({
      type: FETCH_DOCSCLIENT_BYID,
      data: response,
    });
    return Promise.resolve([]);
  });
};
export const FetchLinkClientById = (clientid) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/FetchLinkClientById`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      clientid: clientid,
    },
  }).then((response) => {
    dispatch({
      type: FETCH_LINKCLIENT_BYID,
      data: response,
    });
    return Promise.resolve([]);
  });
};
export const FetchContactsByClientId = (clientid) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/FetchContactsByClientId`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      clientid: clientid,
    },
  }).then((response) => {
    dispatch({
      type: FETCH_CONTACTSCLIENT_BYID,
      data: response,
    });
    return Promise.resolve([]);
  });
};
export const DeleteTags = (tagid) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/DeleteTag`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      tagid: tagid,
    },
  }).then((response) => {
    dispatch({
      type: DELETE_TAGS,
      data: response,
    });
    return Promise.resolve([]);
  });
};
export const DeleteDocs = (documentid) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/Files/Deletedocument`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      documentid: documentid,
    },
  }).then((response) => {
    dispatch({
      type: DELETE_DOCS,
      data: response,
    });
    return Promise.resolve([]);
  });
};
export const AddContact =
  (
    userid,
    companyid,
    firstname,
    lastname,
    jobtitle,
    photo,
    contacttype,
    dateofbirth,
    maritalstatus,
    relationship,
    accountmanager,
    notes,
    clientname,
    priorityid,
    phoneNumbers,
    emails,
    addresses,
    tag,
  ) =>
  async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/User/AddContacts`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        userid: userid,
        companyid: companyid,
        firstname: firstname,
        lastname: lastname,
        jobtitle: jobtitle,
        photo: photo,
        contacttype: contacttype,
        dateofbirth: dateofbirth,
        maritalstatus: maritalstatus,
        relationship: relationship,
        accountmanager: accountmanager,
        notes: notes,
        clientname: clientname,
        isdeleted: 0,
        priorityid: priorityid,
        phoneNumbers: phoneNumbers,
        emails: emails,
        addresses: addresses,
        tag: tag,
      },
    }).then((response) => {
      dispatch({
        type: ADD_CONTACTS,
        data: response,
      });
      return Promise.resolve([]);
    });
  };

export const AddSupplier =
  (
    suppliername,
    email,
    phonenumber,
    address,
    vatNumber,
    iban,
    website,
    paymentconditions,
    notes,
    supplierContact,
  ) =>
  async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/User/CreateSupplier`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        suppliername: suppliername,
        email: email,
        phonenumber: phonenumber,
        address: address,
        vatNumber: vatNumber,
        iban: iban,
        website: website,
        paymentconditions: paymentconditions,
        notes: notes,
        supplierContact: supplierContact,
      },
    }).then((response) => {
      dispatch({
        type: ADD_SUPPLIER,
        data: response,
      });
      return Promise.resolve([]);
    });
  };

export const UpdateSupplier =
  (
    id,
    suppliername,
    email,
    phonenumber,
    address,
    vatNumber,
    iban,
    website,
    paymentconditions,
    notes,
    supplierContact,
  ) =>
  async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/User/UpdateSupplierById`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        supplierid: id,
        suppliername: suppliername,
        email: email,
        phonenumber: phonenumber,
        address: address,
        vatNumber: vatNumber,
        iban: iban,
        website: website,
        paymentconditions: paymentconditions,
        notes: notes,
        supplierContact: supplierContact,
      },
    }).then((response) => {
      dispatch({
        type: UPDATE_SUPPLIER,
        data: response,
      });
      return Promise.resolve([]);
    });
  };

export const AddCompanyContact =
  (
    userid,
    clientname,
    streetnameandnumber,
    zipcode,
    city,
    country,
    officephoneno,
    officephonenotype,
    mobileno,
    mobilenotype,
    email,
    alternativeemail,
    numberofemployees,
    url,
    notes,
    vatnumber,
    paymentconditions,
    ponumber,
    accountmanager,
    duedate,
  ) =>
  async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/User/LinkOrAddCLient`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        userid: userid,
        clientname: clientname,
        streetnameandnumber: streetnameandnumber,
        zipcode: zipcode,
        city: city,
        country: country,
        officephoneno: officephoneno,
        officephonenotype: officephonenotype,
        mobileno: mobileno,
        mobilenotype: mobilenotype,
        email: email,
        alternativeemail: alternativeemail,
        numberofemployees: numberofemployees,
        url: url,
        notes: notes,
        vatnumber: vatnumber,
        paymentconditions: paymentconditions,
        ponumber: ponumber,
        accountmanager: accountmanager,
        duedate: duedate,
      },
    }).then((response) => {
      dispatch({
        type: ADD_COMPANY,
        data: response,
      });
      return Promise.resolve([]);
    });
  };
export const UpdateCompanyContact =
  (
    clientid,
    clientname,
    streetnameandnumber,
    zipcode,
    city,
    country,
    officephoneno,
    officephonenotype,
    mobileno,
    mobilenotype,
    email,
    alternativeemail,
    numberofemployees,
    url,
    notes,
    vatnumber,
    paymentconditions,
    ponumber,
    accountmanager,
    duedate,
  ) =>
  async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/User/UpdateLinkClient`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        clientid: clientid,
        clientname: clientname,
        streetnameandnumber: streetnameandnumber,
        zipcode: zipcode,
        city: city,
        country: country,
        officephoneno: officephoneno,
        officephonenotype: officephonenotype,
        mobileno: mobileno,
        mobilenotype: mobilenotype,
        email: email,
        alternativeemail: alternativeemail,
        numberofemployees: numberofemployees,
        url: url,
        notes: notes,
        vatnumber: vatnumber,
        paymentconditions: paymentconditions,
        ponumber: ponumber,
        accountmanager: accountmanager,
        duedate: duedate,
      },
    }).then((response) => {
      dispatch({
        type: UPDATE_COMPANY,
        data: response,
      });
      return Promise.resolve([]);
    });
  };
export const UpdateContacts =
  (
    userid,
    companyid,
    clientname,
    firstname,
    lastname,
    jobtitle,
    photo,
    contacttype,
    dateofbirth,
    maritalstatus,
    relationship,
    accountmanager,
    notes,
    priorityid,
    emails,
    addresses,
    phoneNumbers,
    tag,
  ) =>
  async (dispatch) => {
    await axios({
      method: "post",
      url: `${CHAT_API_URL}/api/User/UpdateContact`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        userid: userid,
        contactid: companyid,
        clientname: clientname,
        firstname: firstname,
        lastname: lastname,
        jobtitle: jobtitle,
        photo: photo,
        contacttype: contacttype,
        dateofbirth: dateofbirth,
        maritalstatus: maritalstatus,
        relationship: relationship,
        accountmanager: accountmanager,
        notes: notes,
        priorityid: priorityid,
        contactemail: emails,
        contactaddress: addresses,
        contactphonenumber: phoneNumbers,
        contacttags: tag,
      },
    }).then((response) => {
      dispatch({
        type: UPDATE_CONTACTS,
        data: response,
      });
      return Promise.resolve([]);
    });
  };
export const VerifySignup = (userid) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${CHAT_API_URL}/api/User/VerifySignup`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      userid,
      isverified: 1,
    },
  }).then((response) => {
    dispatch({
      type: USER_VERIFY,
      data: response,
    });
    return Promise.resolve([]);
  });
};
export const EmailExistOrNot = (email) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/EmailExistOrNot`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      email,
    },
  }).then((response) => {
    dispatch({
      type: EMAIL_EXIST_OR_NOT,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};
export const user_logout = (userID) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/Logout`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      userid: userID,
    },
  }).then((response) => {
    dispatch({
      type: USER_LOGOUT,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const forgotPassword =
  (userid, password, confirmPassword, passwordToken) => (dispatch) => {
    axios({
      method: "post",
      url: `${API_URL}/api/User/ForgotPassword`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        userid: userid,
        password: password,
        confirmPassword: confirmPassword,
        token: passwordToken,
      },
    }).then((response) => {
      dispatch({
        type: FORGOT_PASS,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };

export const login =
  (email, password, companyid, appName, env = "") =>
  (dispatch) => {
    axios({
      method: "post",
      url: `${API_URL}/api/User/Login`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        email: email,
        password: password,
        environment: env,
        companyid: companyid,
        appName: appName,
      },
    }).then((response) => {
      dispatch({
        type: USER_LOGIN,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };

export const serverLogin =
  (email, password, env = "") =>
  (dispatch) => {
    axios({
      method: "post",
      url: `${API_URL}/api/User/ServerLogin`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        email: email,
        password: password,
        environment: env,
      },
    }).then((response) => {
      dispatch({
        type: USER_LOGIN,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };

export const fetchMyFacebook = (userid) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/User/FetchMyFacebook`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      userid: userid,
    },
  }).then((response) => {
    dispatch({
      type: FETCH_MYFACEBOOK,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const emailSend = (to, companyId) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/User/SendEmail`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      subject: "Successfully Forgot Password",
      to: to,
      companyId: companyId,
      eventid: "08dc57cc-9bed-42f1-8a72-4a766eaf2002 ",
      name: "spire solution",
    },
  }).then((response) => {
    dispatch({
      type: SEND_EMAIL,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const FetchCompanyDetails = (workspacename) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/Company/FetchCompanyDetails`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        workspacename,
      },
    });
    dispatch({
      type: SUB_DOMAIN_NAME,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: SUB_DOMAIN_NAME,
      data: error.message,
    });
  }
};

export const fetchRoleModule = (roleId) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/FetchRolemodule`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      roleid: roleId,
    },
  }).then((response) => {
    dispatch({
      type: FETCH_ROLE_MODULE,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const FetchUserById = (userid) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/FetchUserById`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      userid,
    },
  }).then((response) => {
    dispatch({
      type: FETCH_USER_BY_ID,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const Fetchdocumentbyuserid = (userid) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/Files/Fetchdocumentbyuserid`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      userid,
    },
  }).then((response) => {
    dispatch({
      type: FETCH_DOCUMENT_BY_ID,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const UploadToS3 = () => (dispatch) => {
  axios({
    method: "put",
    url: `${API_URL}/api/Files/UploadToS3`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {},
  }).then((response) => {
    dispatch({
      type: UPLOAD_TO,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const AddDocToUser = (senderid, userid, doc) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/Files/Adddocumenttouser`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      senderid: senderid,
      userid: userid,
      doc: doc,
    },
  }).then((response) => {
    dispatch({
      type: ADD_DOC_TO_USER,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};
export const AddDocToUserContacts = (senderid, userid, doc) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/Files/Adddocumenttocontact`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      contactid: senderid,
      userid: userid,
      docs: doc,
    },
  }).then((response) => {
    dispatch({
      type: ADD_DOC_TO_CONTACT,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const AddDocToSupplier = (senderid, doc) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/Files/AddDocumentToSupplier`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      supplierid: senderid,
      supplierdocs: doc,
    },
  }).then((response) => {
    dispatch({
      type: ADD_DOC_TO_SUPPLIER,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};
export const AddDocToClients = (clientid, userid, doc) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/Files/Adddocumenttoclient`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      clientid: clientid,
      userid: userid,
      docs: doc,
    },
  }).then((response) => {
    dispatch({
      type: ADD_DOC_TO_CLIENT,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const createUser = (data) => (dispatch) => {
  return axios({
    method: "post",
    url: `${API_URL}/api/User/Create`,
    headers: {
      "Content-Type": "application/json",
    },

    data: { ...data },
  })
    .then((response) => {
      dispatch({
        type: USER_CREATE,
        data: response.data,
      });
      return response.data;
    })
    .then((res) => {
      if (res?.status === true) {
        dispatch(SendEmailforRegistering(data.companyid, data.email));
      }
      return res;
    });
};

export const updateUser = (data) => (dispatch) => {
  axios({
    method: "post",
    url: `${CHAT_API_URL}/api/User/Update`,
    headers: {
      "Content-Type": "application/json",
    },
    data: { ...data },
  }).then((response) => {
    dispatch({
      type: USER_UPDATE,
      data: response.data,
    });
  });
};
export const clearUpdateUser = () => {
  return {
    type: CLEAR_USER_UPDATE,
  };
};

export const deleteDoc = (documentid) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/Files/Deletedocument`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      documentid: documentid,
    },
  }).then((response) => {
    dispatch({
      type: DELETE_DOCUMENET,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const getUserNotifications =
  (userid, options = {}) =>
  (dispatch) => {
    const params = new URLSearchParams();

    if (options?.filter) {
      params.set("filter", options.filter);
    }

    if (options?.filterId) {
      params.set("filterId", options.filterId);
    }

    const queryString = params.toString();
    const url = queryString
      ? `${CHAT_API_URL}/api/User/FetchUserNotifications/${userid}?${queryString}`
      : `${CHAT_API_URL}/api/User/FetchUserNotifications/${userid}`;

    return axios.get(url).then((response) => {
      dispatch({
        type: FETCH_USER_NOTIFICATION,
        data: response.data.data,
      });
      return response.data.data;
    });
  };

export const fetchBookmarkedNotifications = (userid) =>
  axios
    .get(`${CHAT_API_URL}/api/User/FetchBookmarkedNotifications/${userid}`)
    .then((response) => response.data);

export const fetchArchivedNotifications = (userid) =>
  axios
    .get(`${CHAT_API_URL}/api/User/FetchArchivedNotifications/${userid}`)
    .then((response) => response.data);

export const bookmarkNotification = (notificationId) =>
  axios
    .post(`${CHAT_API_URL}/api/User/BookmarkNotification/${notificationId}`)
    .then((response) => response.data);

export const unbookmarkNotification = (notificationId) =>
  axios
    .post(`${CHAT_API_URL}/api/User/UnbookmarkNotification/${notificationId}`)
    .then((response) => response.data);

export const archiveNotification = (notificationId) =>
  axios
    .post(`${CHAT_API_URL}/api/User/ArchiveNotification/${notificationId}`)
    .then((response) => response.data);

export const unarchiveNotification = (notificationId) =>
  axios
    .post(`${CHAT_API_URL}/api/User/UnarchiveNotification/${notificationId}`)
    .then((response) => response.data);

// export const markAsReadNotification = (notificationId, userid) => (dispatch) => {
//   axios.get(`${CHAT_API_URL}/api/User/ReadNotification/${notificationId}`).then((response) => {
//     dispatch(getUserNotifications(userid));
//   })
// };

export const fetchTaskByCompanyId =
  (companyId, querystring, startDate, endDate, filter) => async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchTasksByCompanyId`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        companyid: companyId,
        querystring: querystring,
        startDate: startDate,
        endDate: endDate,
        filters: filter,
      },
    }).then((response) => {
      dispatch({
        type: FETCH_TASKS_BY_COMPANY_ID,
        data: response?.data,
      });
      return Promise.resolve([]);
    });
  };

export const fetchTask = (taskid) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/FetchTaskById`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      taskid,
    },
  }).then((response) => {
    dispatch({
      type: FETCH_TASK_BY_ID,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const updateTask =
  (
    userid,
    taskid,
    taskname,
    taskdescription,
    image,
    statusid,
    priorityid,
    duedatetime,
    notificationunit,
    notificationvalue,
    contactid,
    projectid,
    taskdependencies,
    taskchecklist,
    taskassignee,
    estimatedTime,
    workaddress,
    taskequipment,
    sectionid,
    startingDate,
    endDate,
    singnature,
  ) =>
  async (dispatch) => {
    await axios({
      method: "post",
      url: `${CHAT_API_URL}/api/User/UpdateTask`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        userid,
        taskid,
        taskname,
        taskdescription,
        // image,
        image: "", // <-- yaha fix empty string bhej rahe hain
        statusid,
        priorityid,
        duedatetime,
        notificationunit,
        notificationvalue,
        contactid,
        projectid,
        taskdependencies,
        taskchecklist,
        taskassignee,
        estimatedTime,
        workaddress,
        taskequipment,
        sectionid,
        startingDate,
        endDate,
        singnature,
      },
    }).then((response) => {
      dispatch({
        type: UPDATE_TASK,
        data: response.data,
      });
      return Promise.resolve([]);
    });
    return Promise.resolve([]);
  };
/* Deprectated */
export const updateTaskIndex = async (
  companyId,
  taskid,
  statusid,
  source,
  destination,
  isStatusChange = false,
  isDrag = true,
  weekNo = 0,
) => {
  return await axios({
    method: "post",
    url: `${CHAT_API_URL}/api/User/ChangeTaskIndex`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      companyId,
      taskid,
      statusid,
      source,
      destination,
      isStatusChange,
      isDrag,
      weekNo,
    },
  });
};

export const updateOrdersIndexPositions = (orders) => (dispatch) => {
  axios.post(`${API_URL}/api/User/UpdateIndexPositions`, orders);
};
///////////////////////////////////////////TASK//////////////////////////////////////////////////

const API_URL2 = "https://13_speciaal_dev_api.spire.solutions";
export const AddComments =
  (userId, relatedTo, message, type, imgUrl, taggedUser = []) =>
  async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/User/AddComments`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        userid: userId,
        relatedtoid: relatedTo,
        message: message,
        type: type,
        attachments: imgUrl,
        taggedUser: taggedUser,
      },
    }).then((response) => {
      dispatch({
        type: ADD_COMM,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };

export const switchCompany = (userID, isCurrentCompany) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/SwitchCompany`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      userid: userID,
      iscurrentcompany: isCurrentCompany,
    },
  }).then((response) => {
    dispatch({
      type: IS_CURRENTCOMPANY,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const fetchUsersByCompany =
  (isCurrentCompany, pagenumber) => async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchUsersByCompany`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        companyid: isCurrentCompany,
        pagenumber,
      },
    }).then((response) => {
      dispatch({
        type: FETCH_USER_BY_COMPANY,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };

export const fetchLinkClients = () => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/FetchLinkClients`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {},
  }).then((response) => {
    dispatch({
      type: FETCH_LINK,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const fetchProjectByCompany = (companyId) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/FetchContactsClientByCompanyId`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      companyid: companyId,
    },
  }).then((response) => {
    dispatch({
      type: FETCH_PROJECT_BY_COMPANY,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};
export const deleteChecklist = (checklistid) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/DeleteChecklist`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      checklistid: checklistid,
    },
  }).then((response) => {
    dispatch({
      type: DELETE_CHECKLIST,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const addCheckList = (userid, checklisttitle) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/AddChecklists`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      userid: userid,
      checklisttitle: checklisttitle,
    },
  }).then((response) => {
    dispatch({
      type: ADD_CHECKLIST,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};
export const addTask =
  (
    userid,
    companyid,
    projectid,
    taskname,
    taskdescription,
    contactid,
    statusid,
    priorityid,
    duedatetime,
    notificationunit,
    notificationvalue,
    type,
    dependencies,
    estimatedTime,
    checklist,
    assignee,
    workaddress,
    equipment,
    sectionid,
    startingDate,
    endDate,
    taskdocument,
  ) =>
  async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/User/AddTasks`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        userid,
        companyid,
        projectid,
        taskname,
        taskdescription,
        contactid,
        statusid,
        priorityid,
        duedatetime,
        notificationunit,
        notificationvalue,
        type,
        dependencies,
        estimatedTime,
        checklist,
        assignee,
        workaddress,
        equipment,
        sectionid,
        startingDate,
        endDate,
        taskdocument,
      },
    }).then((response) => {
      dispatch({
        type: ADD_TASK,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };

export const markAsReadNotification =
  (notificationId, userid) => (dispatch) => {
    axios
      .get(`${CHAT_API_URL}/api/User/ReadNotification/${notificationId}`)
      .then((response) => {
        dispatch(getUserNotifications(userid));
      });
  };

export const fetchTaskByContactId = (contactid) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/FetchTasksByContactId`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      contactid: contactid,
    },
  }).then((response) => {
    dispatch({
      type: FETCH_TASK_BY_CONTACT_ID,
      data: response?.data,
    });
    return Promise.resolve([]);
  });
};

export const deleteTask =
  (taskid, undo = false) =>
  async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/User/DeleteTask`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        taskid,
        undo: undo,
        userid: window.localStorage.getItem("userid"),
      },
    }).then((response) => {
      dispatch({
        type: DELETE_TASK,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };

export const updateTaskStatus2 = (companyid, taskid) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/UpdateTaskStatus`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      companyid,
      taskid,
    },
  }).then((response) => {
    dispatch({
      type: UPDATE_TASK_STATUS,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const taskForAWeek =
  (companyid, duedatetime, filter) => async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/User/TaskForAWeek`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        companyid,
        duedatetime,
        filters: filter,
      },
    }).then((response) => {
      dispatch({
        type: TASK_FOR_A_WEEK,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };

export const calendarDataSectionUpdate =
  (taskid, duedatetime, statusId) => async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/Dashboard/ChangeTaskDueDate`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        taskId: taskid,
        dueDate: duedatetime,
        statusId,
      },
    }).then((response) => {
      dispatch({
        type: UPDATE_CALENDAR_DATA,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };

export const calendarDataStatusUpdate =
  (taskid, type, statusid, duedatetime) => async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/User/CalendarDataUpdate`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        taskid,
        type,
        statusid,
        duedatetime,
      },
    }).then((response) => {
      dispatch({
        type: UPDATE_CALENDAR_DATA,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };

// export const updateTaskStatus2 = ( companyid, taskid) => async (dispatch) => {
//   await axios({
//     method: "post",
//     url: `${API_URL}/api/User/UpdateTaskStatus`,
//     headers: {
//       "Content-Type": "application/json",
//     },
//     data: {
//       companyid,
//       taskid,

//     },
//   }).then((response) => {
//     dispatch({
//       type: UPDATE_TASK_STATUS,
//       data: response.data,
//     });
//     return Promise.resolve([]);
//   });
// };

export const FetchActiveUsers = (companyid) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/FetchActiveUsers`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      companyid: companyid,
    },
  }).then((response) => {
    dispatch({
      type: ACTIVE_STATUS,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};
export const FetchActiveUsersList = (companyid) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/FetchActiveUsersList`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      companyid: companyid,
    },
  }).then((response) => {
    dispatch({
      type: FETCH_ACTIVE_USER_LIST,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const FetchTeamsList = () => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/FetchTeamsList`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {},
  }).then((response) => {
    dispatch({
      type: FETCH_TEAMS_LIST,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

////////////////////// ASC GROUPING API START ////////////////////

export const TaskGrouping = () => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/TaskGrouping`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {},
  }).then((response) => {
    dispatch({
      type: TASK_GROUPING,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const FetchTaskWeekly = (weekNumber) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/FetchTaskWeekly`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      weekNumber,
    },
  }).then((response) => {
    dispatch({
      type: FETCH_WEEKLY,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};
export const FetchRoleModuleAccess = (roleid) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/FetchRoleModuleAccess`,
    headers: {
      "Content-Type": "application/json",
    },
    data: { roleid },
  }).then((response) => {
    dispatch({
      type: FATCH_ROLEMODULE_ACCESS,
      data: response,
    });
    return Promise.resolve([]);
  });
};

////////////////////// ASC GROUPING API END /////////////////////

////////////////////// ASC PROJECT TILESVIEW START /////////////////////

export const FetchProject = (companyid) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/FetchProject`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      companyid: companyid,
    },
  }).then((response) => {
    dispatch({
      type: FETCH_PROJECT,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const FetchProjectBB =
  (companyid, filter, packageId) => async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchProject`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        companyid: companyid,
        filter: filter,
        packageid: packageId,
      },
    }).then((response) => {
      dispatch({
        type: FETCH_PROJECT_BB,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };

export const fetchTaskByProject = (projectid) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/FetchTaskByProject`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      projectid: projectid,
    },
  }).then((response) => {
    dispatch({
      type: FETCH_TASK_BY_PROJECT,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const CreateProject =
  (
    userid,
    projectname,
    clientid,
    contactemail,
    contactphonenumber,
    completiondate,
    statuscode,
    projectmanagerid,
    deliveryAddress,
    contactForDelivery,
    projectcover,
    notes,
    priorityid,
    projectDescription,
    startingDate,
    noOfWeeks,
    needPO,
    billing,
    paymentTerms,
    creditLimit,
    balance,
    status,
    addressParts = {},
  ) =>
  async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/User/CreateProject`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        userid: userid,
        projectname: projectname,
        clientid: clientid,
        contactemail: contactemail,
        contactphonenumber: contactphonenumber,
        completiondate: completiondate,
        statuscode: statuscode,
        projectmanagerid: projectmanagerid,
        deliveryAddress: deliveryAddress,
        contactForDelivery: contactForDelivery,
        projectcover: projectcover,
        notes: notes,
        priorityid: priorityid,
        projectDescription: projectDescription,
        startingDate: startingDate,
        noOfWeeks: noOfWeeks,
        needPO: needPO,
        billing: billing,
        paymentTerms: paymentTerms,
        creditLimit: creditLimit,
        balance: balance,
        status: status,
        street: addressParts.street || "",
        city: addressParts.city || "",
        state: addressParts.state || "",
        pinCode: addressParts.pinCode || "",
        country: addressParts.country || "",
      },
    }).then((response) => {
      axios({
        method: "post",
        url: `${API_URL}/api/WorkFlow/WorkflowAutomationProjectCreationSequence`,
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          projectId: response.data.data.projectid,
        },
      }).then((resp) => {
        console.log(resp.data);
      });

      dispatch({
        type: CREATE_PROJECT,
        data: response.data,
      });

      return Promise.resolve([]);
    });
  };

export const FetchClient = () => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/FetchClient`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {},
  }).then((response) => {
    dispatch({
      type: FETCH_CLIENT,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const FetchActiveUser = (companyid) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/FetchActiveUsers`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      companyid: companyid,
    },
  }).then((response) => {
    dispatch({
      type: FETCH_ACTIVE_USER,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const FetchProjectById = (projectid) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/FetchProjectById`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      projectid: projectid,
    },
  }).then((response) => {
    dispatch({
      type: FETCH_PROJECT_BY_ID,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const UpdateProjectById =
  (
    projectid,
    projectname,
    clientid,
    contactemail,
    contactphonenumber,
    completiondate,
    statuscode,
    projectmanagerid,
    deliveryAddress,
    contactForDelivery,
    projectcover,
    notes,
    priorityid,
    projectDescription,
    startingDate,
    noOfWeeks,
    needPO,
    billing,
    paymentTerms,
    creditLimit,
    balance,
    status,
    addressParts = {},
  ) =>
  async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/User/UpdateProjectById`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        projectid: projectid,
        projectname: projectname,
        clientid: clientid,
        contactemail: contactemail,
        contactphonenumber: contactphonenumber,
        completiondate: completiondate,
        statuscode: statuscode,
        projectmanagerid: projectmanagerid,
        deliveryAddress: deliveryAddress,
        contactForDelivery: contactForDelivery,
        projectcover: projectcover,
        notes: notes,
        priorityid: priorityid,
        projectDescription: projectDescription,
        startingDate: startingDate,
        noOfWeeks: noOfWeeks,
        needPO: needPO,
        billing: billing,
        paymentTerms: paymentTerms,
        creditLimit: creditLimit,
        balance: balance,
        status: status,
        street: addressParts.street || "",
        city: addressParts.city || "",
        state: addressParts.state || "",
        pinCode: addressParts.pinCode || "",
        country: addressParts.country || "",
      },
    }).then((response) => {
      dispatch({
        type: UPDATE_PROJECT_BY_ID,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };

export const AddDocumentToProject =
  (userid, projectid, projectdocs) => async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/Files/Adddocumenttoproject`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        userid: userid,
        projectid: projectid,
        projectdocs: projectdocs,
      },
    }).then((response) => {
      dispatch({
        type: ADD_DOCUMENT_PROJECT,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };

export const Fetchdocumentbyprojectid = (projectid) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/Files/Fetchdocumentbyprojectid`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      projectid: projectid,
    },
  }).then((response) => {
    dispatch({
      type: FETCH_DOCUMENT_PROJECT,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

////////////////////// ASC PROJECT TILESVIEW END /////////////////////

export const myTaskToday = (userid) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/FetchTodayTaskList`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      userid: userid,
    },
  }).then((response) => {
    dispatch({
      type: TASK_TODAY,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const ChangeStatus = (taskid, statusid) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/ChangeStatus`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      taskid,
      statusid,
      jwtToken: localStorage.getItem("token"),
    },
  }).then((response) => {
    dispatch({
      type: CHANGE_STATUS,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

//// ASC PURCHASING ORDER START ////

export const Fetchprojects = () => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/Fetchprojects`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {},
  }).then((response) => {
    dispatch({
      type: FETCH_PROJECTS,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const FetchProductBysupplierid =
  (supplierid, forJIT = false) =>
  async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchProductBysupplierid`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        supplierid: supplierid,
        forJIT: forJIT,
      },
    }).then((response) => {
      dispatch({
        type: FETCH_PRODUCT_BY_SUPPLIER_ID,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };

export const Addpurchasingorder =
  (
    orderdescription,
    supplierid,
    projectid,
    orderproduct,
    sendEmail,
    totalexclusivebtw,
    totalinclusivebtw,
    address,
    type,
    fromDate,
    toDate,
  ) =>
  async (dispatch) => {
    console.log("orderproduct=====================>", orderproduct);
    await axios({
      method: "post",
      url: `${API_URL}/api/User/AddPurchasingOrder`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        orderdescription: orderdescription,
        supplierid: supplierid,
        projectid: projectid,
        sendEmail: sendEmail,
        totalexclusivebtw,
        totalinclusivebtw,
        orderproduct: orderproduct,
        address,
        type,
        rentPeriodFrom: fromDate,
        rentPeriodTo: toDate,
      },
    }).then((response) => {
      dispatch({
        type: ADD_PURCHASING_ORDER,
        data: response.data,
      });
    });
  };

export const SendEmailforPurchasing = (to) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/User/SendEmail`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      subject: "Successfully Mail Send To Supplier",
      to: to,
      eventid: "08dc57cc-9bed-42f1-8a72-4a766eaf2003",
      name: "spire solution",
    },
  }).then((response) => {
    dispatch({
      type: SEND_EMAIL_FOR_PURCHASING_ORDER,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const Fetchlastordercode = () => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/User/Fetchlastordercode`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {},
  }).then((response) => {
    dispatch({
      type: FETCH_PO_ORDER_CODE,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};
//// ASC PURCHASING ORDER END ////
export const FetchWarehousePurchasingOrder =
  (pagerequire, pagenumber, querystring) => (dispatch) => {
    axios({
      method: "post",
      url: `${API_URL}/api/User/FetchWarehousePurchasingOrder`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        pagerequire: pagerequire,
        pagenumber: pagenumber,
        querystring: querystring,
      },
    }).then((response) => {
      dispatch({
        type: FETCH_WAREHOUSE_PURCHASING_ORDER,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };
export const FetchPurchasingOrder = (orderid) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/User/FetchPurchasingOrder`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      orderid: orderid,
    },
  }).then((response) => {
    dispatch({
      type: FETCH_PURCHASING_ORDER,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};
export const AddToWarehouse = (payload) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/User/AddToWarehouse`,
    headers: {
      "Content-Type": "application/json",
    },
    data: payload,
  }).then((response) => {
    dispatch({
      type: ADD_TO_WAREHOUSE,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};
export const FetchEquipmentTaskList = (payload) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/User/FetchEquipmentList`,
    headers: {
      "Content-Type": "application/json",
    },
    data: payload,
  }).then((response) => {
    dispatch({
      type: FETCH_EQUIPMENT_TASK_LIST,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};
export const UpdateOrderProductQty = (payload) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/User/UpdateOrderProductQty`,
    headers: {
      "Content-Type": "application/json",
    },
    data: payload,
  }).then((response) => {
    dispatch({
      type: UPDATE_ORDER_PRODUCT_QTY,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};
export const AddItemInExistingOrder = (payload) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/User/AddItemInExistingOrder`,
    headers: {
      "Content-Type": "application/json",
    },
    data: payload,
  }).then((response) => {
    dispatch({
      type: ADD_ITEM_IN_EXISTING_ORDER,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};
//product & part start
export const FetchProduct = (payload) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/User/FetchProduct/PartByCompany`,
    headers: {
      "Content-Type": "application/json",
    },
    data: payload,
  }).then((response) => {
    dispatch({
      type: FETCH_PRODUCT,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};
export const FetchProductionHistory = (payload) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/Stocks/productionhistory`,
    headers: {
      "Content-Type": "application/json",
    },
    data: payload,
  }).then((response) => {
    dispatch({
      type: FETCH_PRODUCTION_HISTORY,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};
export const DeleteProduct = (productpartid) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/User/DeleteProduct/Part`,
    headers: {
      "Content-Type": "application/json",
    },
    data: { productpartid },
  }).then((response) => {
    dispatch({
      type: DELETE_PRODUCT,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};
export const FetchSuppliers = () => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/User/Fetchsuppliers`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {},
  }).then((response) => {
    dispatch({
      type: FETCH_SUPPLIERS_PRODUCT,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};
export const FetchPartsList = () => (dispatch) => {
  axios({
    method: "get",
    url: `${API_URL}/api/Stocks/composeproduct/getpartslist`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {},
  }).then((response) => {
    dispatch({
      type: FETCH_PARTS_LIST,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};
export const FetchProductPart = (payload) => (dispatch) => {
  axios({
    method: "get",
    url: `${API_URL}/api/Stocks/getproductparts/${payload.productpartid}`,
    headers: {
      "Content-Type": "application/json",
    },
    data: payload,
  }).then((response) => {
    dispatch({
      type: FETCH_PRODUCT_PART,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};
export const FetchDocumentByProductPartId = (payload) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/Files/FetchdocumentbyProductPartid`,
    headers: {
      "Content-Type": "application/json",
    },
    data: payload,
  }).then((response) => {
    dispatch({
      type: FETCH_DOCUMENT_BY_PRODUCT_PART_ID,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};
export const AddProductPart = (payload) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/Stocks/composeproduct/add`,
    headers: {
      "Content-Type": "application/json",
    },
    data: payload,
  }).then((response) => {
    dispatch({
      type: ADD_PRODUCT_PART,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};
export const UpdateProduct = (payload) => (dispatch) => {
  axios({
    method: "put",
    url: `${API_URL}/api/Stocks/composeproduct/update`,
    headers: {
      "Content-Type": "application/json",
    },
    data: payload,
  }).then((response) => {
    dispatch({
      type: UPDATE_PRODUCT_PART,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};
export const ProductPartCodeEmailExistOrNot = (payload) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/User/ProductPartCodeEmailExistOrNot`,
    headers: {
      "Content-Type": "application/json",
    },
    data: payload,
  }).then((response) => {
    dispatch({
      type: PRODUCT_PART_CODE_EMAIL_EXIST_OR_NOT,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};
export const UpdateIslocked = (payload) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/Files/UpdateIslocked`,
    headers: {
      "Content-Type": "application/json",
    },
    data: payload,
  });
};
export const AddDocumentToProductPart = (payload) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/Files/AdddocumenttoProductPart`,
    headers: {
      "Content-Type": "application/json",
    },
    data: payload,
  });
};
export const emptyTaskState = () => (dispatch) => {
  dispatch({ type: "EMPTY_TASK_STATE", data: {} });
};
export const EmptyProductPart = () => (dispatch) => {
  dispatch({
    type: EMPTY_PRODUCT_PART,
    data: [],
  });
};
export const addColorCode = (color) => ({
  type: ADD_COLOR_CODE,
  data: color,
});
export const deleteColor = (index) => {
  return {
    type: DELETE_COLOR,
    payload: index,
  };
};
export const addStockColorCode = (color) => ({
  type: ADD_STOCK_COLOR_CODE,
  data: color,
});
export const deleteStockColor = (index) => {
  return {
    type: DELETE_STOCK_COLOR,
    payload: index,
  };
};

export const getAppSideBarOptions = () => (dispatch) => {
  const companyId = window.localStorage.getItem("companyid");
  if (companyId) {
    axiosInstance
      .get(`${CHAT_API_URL}/api/User/FetchAccessModules?CompanyId=${companyId}`)
      .then((respose) => {
        dispatch({
          type: "SET_APP_SIDENAV_OPTIONS",
          data: respose?.data?.data || [],
        });
      });
  }
};
export const TotalStockAvailable = () => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/User/TotalStockAvailable`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {},
  }).then((response) => {
    dispatch({
      type: TOTAL_STOCK_AVAILABLE,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const AdvicedItemPurchaseData = () => (dispatch) => {
  axios({
    method: "get",
    url: `${API_URL}/api/User/AdvisedItemPurchase`,
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => {
    dispatch({
      type: ADVICED_ITEM_PURCHASE,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const JITAdvicedItemPurchaseData = () => (dispatch) => {
  axios({
    method: "get",
    url: `${API_URL}/api/User/JITGetAdvisedItems`,
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => {
    dispatch({
      type: JIT_ADVICED_ITEM_PURCHASE,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const GetAdvicedPurchaseOrderList =
  (pagerequire, pagenumber) => (dispatch) => {
    axios({
      method: "post",
      url: `${API_URL}/api/User/GetAdvicedPurchaseOrderList`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        pagerequire: pagerequire,
        pagenumber: pagenumber,
      },
    }).then((response) => {
      dispatch({
        type: ADVICED_PURCHASE_ORDER_LIST,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };

export const FetchPurchasingAssetList = (assetId) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/Asset/FetchAssetPurchasingOrder`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      assetid: assetId,
    },
  }).then((response) => {
    dispatch({
      type: FETCH_PURCHASING_ASSET_LIST,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};
export const DeletePOAsset = (assetPurchasingOrderid) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/Asset/DeletePO`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      assetPurchasingOrderid: assetPurchasingOrderid,
    },
  }).then((response) => {
    dispatch({
      type: DELETE_PO_ASSET,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};
export const ChangesPOStatus =
  (assetPurchasingOrderid, statusid) => (dispatch) => {
    axios({
      method: "post",
      url: `${API_URL}/api/Asset/ChangesPOStatus`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        assetPurchasingOrderid: assetPurchasingOrderid,
        statusid: statusid,
      },
    }).then((response) => {
      dispatch({
        type: CHANGE_PO_STATUS,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };
export const FetchLastPurchasingOrderCode = (assetId) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/Asset/Fetchlastpurchasingordercode`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      assetid: assetId,
    },
  }).then((response) => {
    dispatch({
      type: FETCH_LAST_PURCHASING_ORDER_CODE_ASSET_LIST,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const AddAssetPurchasingOrder = (payload) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/Asset/AddAssetPurchasingOrder`,
    headers: {
      "Content-Type": "application/json",
    },
    data: payload,
  }).then((response) => {
    dispatch({
      type: ADD_ASSET_PURCHASING_ORDER,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};
export const GetJITPurchaseOrderList =
  (pagerequire, pagenumber) => (dispatch) => {
    axios({
      method: "post",
      url: `${API_URL}/api/User/JITGetAdvicedOrders`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        pagerequire: pagerequire,
        pagenumber: pagenumber,
      },
    }).then((response) => {
      dispatch({
        type: JIT_PURCHASE_ORDER_LIST,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };

export const FetchPurchasingOrderAwaiting = (payload) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/User/FetchPurchasingOrderAwaiting`,
    headers: {
      "Content-Type": "application/json",
    },
    data: payload,
  }).then((response) => {
    dispatch({
      type: FETCH_PURCHASING_ORDER_AWAITING,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};
export const FetchNotEnrolledPayroll = (companyId) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/Payroll/FetchNotEnrolledPayroll`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      companyid: companyId,
    },
  }).then((response) => {
    dispatch({
      type: FETCH_NOT_ENROLLED_PAYROLL,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const FetchPayrollHistory = (payload) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/Payroll/FetchPayrollHistory`,
    headers: {
      "Content-Type": "application/json",
    },
    data: payload,
  }).then((response) => {
    dispatch({
      type: FETCH_PAYROLLHISTORY,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const DeleteProductDocument = (payload) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/Files/Deletedocument`,
    headers: {
      "Content-Type": "application/json",
    },
    data: payload,
  }).then((response) => {
    dispatch({
      type: DELETE_PRODUCT_DOCUMENT,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const AddReturnToWarehouse = (payload) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/User/AddReturnToWarehouse`,
    headers: {
      "Content-Type": "application/json",
    },
    data: payload,
  }).then((response) => {
    dispatch({
      type: ADD_RETURN_TO_WAREHOUSE,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const ProjectDropdown = (payload) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/User/ProjectDropdown`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {},
  }).then((response) => {
    dispatch({
      type: FETCH_PROJECTS_DROPDOWN,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const FetchProjectClient = (clientid) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchProjectClient`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { clientid },
    });
    dispatch({
      type: FETCH_PROJECT_CLIENT,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const ProductDropdown = (payload) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/User/ProductDropdown`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {},
  }).then((response) => {
    dispatch({
      type: FETCH_PRODUCT_DROPDOWN,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const FetchOrderPickingProduct = (sort, projectid) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/User/FetchOrderPickingProduct`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      sortby: sort,
      projectid: projectid,
    },
  }).then((response) => {
    dispatch({
      type: FETCH_ORDER_PICKING_PRODUCT,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const ProductProjectDropdown = (projectId, orderid) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/User/FetchProductDropdown`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      projectid: projectId,
      orderid: orderid,
    },
  }).then((response) => {
    dispatch({
      type: FETCH_PRODUCT_DROPDOWN,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const UpdateProductDropdown = (payload) => {
  return {
    type: UPDATE_PRODUCT_DROPDOWN,
    payload: payload,
  };
};

export const CreateOrderPicking =
  (orderTotal, productId, projectId, purchasingorderid, orderProductQty) =>
  async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/User/CreateOrderPicking`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        projectid: projectId,
        productid: productId,
        purchasingorderid: purchasingorderid,
        ordertotal: orderTotal,
        orderProductqty: orderProductQty,
      },
    }).then((response) => {
      dispatch({
        type: CREATE_ORDER_PICKING,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };

export const UpdateProductPartStock = (updatedStock) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/UpdateProductPartStock`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      productpart: updatedStock,
    },
  }).then((response) => {
    dispatch({
      type: UPDATE_PRODUCT_PART_STOCK,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};
export const UpdateCountStock = (updatedStock) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/CountStock`,
    headers: {
      "Content-Type": "application/json",
    },
    data: updatedStock,
  }).then((response) => {
    dispatch({
      type: UPDATE_COUNT_STOCK,
      data: { ...response.data, data: updatedStock },
    });
    return Promise.resolve([]);
  });
};
export const UpdateCheckCountStock = (updatedStock) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/CheckStock`,
    headers: {
      "Content-Type": "application/json",
    },
    data: updatedStock,
  }).then((response) => {
    dispatch({
      type: UPDATE_CHECK_COUNT_STOCK,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const DeleteProductPartStock = () => {
  return {
    type: DELETE_PRODUCT_PART_STOCK,
  };
};

export const FetchPOByProject =
  (projectId, type, pagenumber, pagerequire) => async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchPOByProject`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        projectid: projectId,
        type: type,
        pagenumber: pagenumber,
        pagerequire: pagerequire,
      },
    }).then((response) => {
      dispatch({
        type: FETCH_PO_BY_PROJECT,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };

export const FetchQuotes =
  (projectId, pagenumber, pagerequire) => async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchQuotes`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        projectid: projectId,
        pagenumber: pagenumber,
        pagerequire: pagerequire,
      },
    }).then((response) => {
      dispatch({
        type: FETCH_QUOTES,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };

export const FetchInvoices =
  (projectId, pagenumber, pagerequire, statusFilter) => async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchInvoices`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        projectid: projectId,
        pagenumber: pagenumber,
        pagerequire: pagerequire,
        statusFilter: statusFilter,
      },
    }).then((response) => {
      dispatch({
        type: FETCH_INVOICES,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };

export const AddInvoices = (invoiceList) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/AddInvoices`,
    headers: {
      "Content-Type": "application/json",
    },
    data: invoiceList,
  }).then((response) => {
    dispatch({
      type: ADD_INVOICES,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const FetchTaskByProject =
  (projectId, pagenumber, recordsPerPage) => async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchTaskByProject`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        projectId,
        pagenumber,
        recordsPerPage,
      },
    }).then((response) => {
      dispatch({
        type: FETCH_TASK_BY_PROJECT,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };

export const FetchlastQuotecode = () => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/FetchlastQuotecode`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {},
  }).then((response) => {
    dispatch({
      type: FETCH_LAST_QUOTE_CODE,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const CreateDuplicateQuotes =
  (quoteid, quotecode) => async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/User/CreateDuplicateQuotes`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        quoteid,
        quotecode,
      },
    }).then((response) => {
      dispatch({
        type: CREATE_DUPLICATE_QUOTES,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };

export const DeactivatedQuote = (quoteid, isstatus) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/DeactivatedQuote`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      quoteid,
      isstatus,
    },
  }).then((response) => {
    dispatch({
      type: DEACTIVATED_QUOTE,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

// export const DeleteProductPartStock = () => {
//   return {
//     type: DELETE_PRODUCT_PART_STOCK
//   };
// };
// export const DeleteProductPartStock = () => {
//   return {
//     type: DELETE_PRODUCT_PART_STOCK,
//   };
// };

export const AddCompanyInfo = (data) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/AddCompanyInfo`,
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  }).then((response) => {
    dispatch({
      type: ADD_COMPANY_DETAILS,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const UpdateCompanyDetails = (data) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/UpdateCompanyInfo`,
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  }).then((response) => {
    dispatch({
      type: ADD_COMPANY_DETAILS,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const FetchCompanyDetailsById = (data) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/FetchComapanyInfoById`,
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  }).then((response) => {
    dispatch({
      type: ADD_COMPANY_DETAILS,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const GetUserTimeSession =
  (userId, page = 1) =>
  async (dispatch) => {
    await axios({
      method: "get",
      url: `${API_URL}/api/TimeManagement/GetUserTimeSession?userId=${userId}&pageNumber=${page}`,
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => {
      dispatch({
        type: GET_USER_TIME_SESSION,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };

export const CheckExistingTimeSession = async (data) =>
  await axios({
    method: "post",
    url: `${API_URL}/api/TimeManagement/CheckExistingTimeSession`,
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  });

export const CreateManualTimeSession = async (data) =>
  await axios({
    method: "post",
    url: `${API_URL}/api/TimeManagement/CreateManualTimeSession`,
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  });

export const UpdateManualTimeSession = async (data) =>
  await axios({
    method: "post",
    url: `${API_URL}/api/TimeManagement/UpdateManualTimeSession`,
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  });

export const DeleteManualTimeSession = async (data) =>
  await axios({
    method: "post",
    url: `${API_URL}/api/TimeManagement/DeleteManualTimeSession`,
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  });

// ASC REDUX PROPS START //
export const Bookkeeping_Props = (book_props) => {
  return {
    type: BOOKKEEPING_PROPS,
    data: book_props,
  };
};
// ASC REDUX PROPS END //

export const CheckIfTimeSessionStartOrNot =
  (projectId, taskid, userId, trackerStartDate, trackerStartTime) =>
  async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/TimeManagement/CheckIfTimeSessionStartOrNot`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        projectId,
        taskid,
        userId,
        trackerStartDate,
        trackerStartTime,
      },
    }).then((response) => {
      dispatch({
        type: CHECK_IF_TIME_SESSION,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };

export const CreateNewTimeSession =
  (
    projectId,
    taskid,
    trackerStartDate,
    trackerStartTime,
    type,
    description,
    isManual,
    userid,
  ) =>
  async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/TimeManagement/CreateNewTimeSession`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        projectId,
        taskid,
        trackerStartDate,
        trackerStartTime,
        type,
        description,
        isManual,
        userid,
      },
    }).then((response) => {
      dispatch({
        type: CREATE_NEW_TIME_SESSION,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };

export const GetTimeSession =
  (projectId, taskid, userId, currentDate, currentTime) => async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/TimeManagement/GetTimeSession`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        projectId,
        taskid,
        userId,
        currentDate,
        currentTime,
      },
    })
      .then((response) => {
        dispatch({
          type: GET_TIME_SESSION,
          data: response.data,
        });
        return Promise.resolve([]);
      })
      .catch((res) => console.log(res));
  };

export const UpdateTimeSession =
  (projectTaskTrackingTimeid, trackerEndDate, trackerEndTime) =>
  async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/TimeManagement/UpdateTimeSession`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        projectTaskTrackingTimeid,
        trackerEndDate,
        trackerEndTime,
      },
    }).then((response) => {
      dispatch({
        type: UPDATE_TIME_SESSION,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };

export const GetActiveTimeSessionOnPlanboard =
  (userId, currentDate, currentTime) => async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/TimeManagement/GetActiveTimeSessionOnPlanboard`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        userId,
        currentDate,
        currentTime,
      },
    }).then((response) => {
      dispatch({
        type: GET_ACTIVE_TIME_SESSION,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };

export const StopTimerFromHeader = (taskId) => async (dispatch) => {
  dispatch({
    type: STOP_TIMER_FROM_HEADER,
    data: taskId,
  });
};

export const Fetchlastprojectcode = () => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/User/Fetchlastprojectcode`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {},
  }).then((response) => {
    dispatch({
      type: FETCH_ADD_PROJECT_ID,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const FetchInvoiceById = (invoiceid) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/FetchInvoiceById`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      invoiceid,
    },
  }).then((response) => {
    dispatch({
      type: FETCH_INVOICE_BY_ID,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const UpdateInvoice =
  (
    invoiceid,
    description,
    duedate,
    totalexclusivebtw,
    totalinclusivebtw,
    vaTpercent,
  ) =>
  async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/User/UpdateInvoice`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        invoiceid,
        description,
        duedate,
        totalexclusivebtw,
        totalinclusivebtw,
        vaTpercent,
      },
    }).then((response) => {
      dispatch({
        type: UPDATE_INVOICE,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };

export const AddCreditNote =
  (
    invoiceId,
    projectid,
    quoteid,
    companyid,
    invoicecode,
    ponumber,
    clientref,
    // paymentdeadline,
    duedate,
    // paymentoptions,
    invoicestatus,
    comment,
    totalexclusivebtw,
    totalinclusivebtw,
    invoicetotal,
    milestones,
  ) =>
  async (dispatch) => {
    try {
      const response = await axios({
        method: "post",
        url: `${API_URL}/api/User/AddCreditNote`,
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          invoiceId,
          projectid,
          quoteid,
          companyid,
          invoicecode,
          ponumber,
          clientref,
          // paymentdeadline,
          duedate,
          // paymentoptions,
          invoicestatus,
          comment,
          totalexclusivebtw,
          totalinclusivebtw,
          invoicetotal,
          milestones,
        },
      });
      dispatch({
        type: ADD_CREDIT_NOTE,
        data: response.data,
      });
      return response.data;
    } catch (error) {
      console.error(error);
    }
  };

export const AddUpdateFinancialByProject = (projectid) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/Add/UpdateFinancialByProject`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      projectid,
    },
  }).then((response) => {
    dispatch({
      type: ADD_UPDATE_FINANCIAL_BY_PROJECT,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const FetchFinancialByProject = (projectid) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/FetchFinancialByProject`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      projectid,
    },
  }).then((response) => {
    dispatch({
      type: FETCH_FINANCIAL_BY_PROJECT,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const OpenTimerFromHeader = (taskId) => (dispatch) => {
  dispatch({
    type: OPEN_TIMER_FROM_HEADER,
    data: taskId,
  });
};

export const changeProjectTab = (tab) => (dispatch) => {
  dispatch({
    type: CHANGE_PROJECT_TAB,
    data: tab,
  });
};

export const setStatusToFalse = () => (dispatch) => {
  dispatch({
    type: SET_STATUS_TO_FALSE,
    data: {},
  });
};

export const setInvoiceStatusToFalse = () => (dispatch) => {
  dispatch({
    type: SET_INVOICE_STATUS_TO_FALSE,
    data: {},
  });
};

export const setCheckTimeSessionToFalse = () => (dispatch) => {
  dispatch({
    type: SET_TIME_SESSION_TO_FALSE,
    data: {},
  });
};

export const downloadPurchasingOrderPDF =
  (orderid, ordercode) => async (dispatch) => {
    let workspaceName = localStorage.getItem("workspaceName")?.split("-")[0];
    // let selectedProject = localStorage.getItem("projectForPrint");
    let selectedQuoteNo = localStorage.getItem("QuoteNoForPrint");
    let selectedClientName = localStorage.getItem("clientNameForPrint");

    let pdfTitle = `${selectedClientName}-${selectedQuoteNo}, Purchase Order-${workspaceName}-${moment(
      new Date(),
    ).format("YYYY.MM.DD, h:mm a")}.pdf`;

    const response = await axiosInstance.get(
      `${API_URL}/api/PurchasingOrderDoc/${orderid}/download`,
      {
        responseType: "blob",
        headers: ["filename"],
      },
    );
    if (response.status == 200) {
      const downloadLink = document.createElement("a");
      downloadLink.href = URL.createObjectURL(response.data);
      // downloadLink.download = `PO_${ordercode.replace(".", "/")}.pdf`;
      downloadLink.download = pdfTitle;
      downloadLink.click();
    }
    return response.status;
  };

export const generateAdvicedPurchaseOrder = () => {
  return axiosInstance.get(`${API_URL}/api/User/GenerateAdvicedOrder`);
};

export const generateJITPurchaseOrder = () => {
  return axiosInstance.get(`${API_URL}/api/User/JITGenerateOrders`);
};

export const PlaceBulkOrder = (projectid) => {
  return axios({
    method: "post",
    url: `${API_URL}/api/User/AdvicedItem/PlaceBulkOrder`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      projectid: projectid,
    },
  });
};

export const JITPlaceBulkOrder = (projectid) => {
  return axios({
    method: "post",
    url: `${API_URL}/api/User/AdvicedItem/JITGenerateBulkPurchaseOrder`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      projectid: projectid,
    },
  });
};

export const deleteTaskIdFromTimer = () => (dispatch) => {
  dispatch({
    type: DELETE_TASK_ID_FROM_TIMER,
    data: {},
  });
};

export const UpdateProjectCover = (projectid, image) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/UpdateProjectCover`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      projectid: projectid,
      image: image,
    },
  }).then((response) => {
    dispatch({
      type: UPDATE_PROJECT_COVER,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const FetchProjectKanBan =
  (companyId, querystring) => async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchProjectByCompany`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        companyid: companyId,
        querystring: querystring,
      },
    }).then((response) => {
      dispatch({
        type: FETCH_PROJECT_KAN_BAN,
        data: response?.data,
      });
      return Promise.resolve([]);
    });
  };

export const ProjectGrouping = () => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/ProjectGrouping`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {},
  }).then((response) => {
    dispatch({
      type: PROJECT_GROUPING,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const FetchProjectsWeekly = (weekNumber) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/FetchProjectsWeekly`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      weekNumber,
    },
  }).then((response) => {
    dispatch({
      type: FETCH_PROJECT_WEEKLY,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};
export const FetchQuotesByCompanyId =
  (pagerequire, pagenumber, search) => async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchQuotesByCompanyid`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        pagerequire,
        pagenumber,
        search,
      },
    }).then((response) => {
      dispatch({
        type: FETCH_QUOTES_BY_COMPANY_ID,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };
export const AddQuotes =
  (projectid, quotescode, total, isstatus, status, margin, unitlabelcost) =>
  async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/User/AddQuotes`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        projectid,
        quotescode,
        total,
        isstatus,
        status,
        margin,
        unitlabelcost,
      },
    }).then((response) => {
      dispatch({
        type: ADD_QUOTES,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };
export const ApproveQuotes =
  (quoteid, jwtToken, taskPerLine) => async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/User/ApproveQuotes`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        quoteid,
        jwtToken,
        taskPerLine,
      },
    }).then((response) => {
      dispatch({
        type: APPROVE_QUOTES,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };
export const AddSection =
  (quoteid, sectionname, indexPosition) => async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/quote/section`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        quoteid,
        sectionname,
        indexPosition,
      },
    }).then((response) => {
      dispatch({
        type: ADD_SECTION,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };
export const DuplicateSection = (sectionid) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/quote/section/${sectionid}/duplicate`,
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => {
    dispatch({
      type: DUPLICATE_SECTION,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};
export const DeleteSection = (quoteid, sectionid) => async (dispatch) => {
  await axios({
    method: "delete",
    url: `${API_URL}/api/quote/${quoteid}/section/${sectionid}`,
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => {
    dispatch({
      type: DELETE_SECTION,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};
export const UpdateProjectStatus = async (projectid, statusid) => {
  return await axios({
    method: "post",
    url: `${CHAT_API_URL}/api/User/UpdateProjectStatus`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      projectid,
      statusid,
    },
  });
};
export const ChangeProjectIndex = async (
  companyId,
  projectid,
  statusid,
  source,
  destination,
  isStatusChange = false,
  isDrag = true,
  weekNo = 0,
) => {
  return await axios({
    method: "post",
    url: `${CHAT_API_URL}/api/User/ChangeProjectIndex`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      companyId,
      projectid,
      statusid,
      source,
      destination,
      isStatusChange,
      isDrag,
      weekNo,
    },
  });
};

export const getQuoteSections = (quoteid) => async (dispatch) => {
  await axios({
    method: "get",
    url: `${API_URL}/api/quote/${quoteid}`,
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => {
    dispatch({
      type: GET_QUOTE_SECTIONS,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};
export const updateQuoteSections = (quoteid, quote) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/quote/${quoteid}`,
    headers: {
      "Content-Type": "application/json",
    },
    data: quote,
  }).then((response) => {
    dispatch({
      type: UPDATE_QUOTE_SECTIONS,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};
export const addSubSection = (sectionid, payload) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/quote/section/${sectionid}/subsection`,
    headers: {
      "Content-Type": "application/json",
    },
    data: payload,
  }).then((response) => {
    dispatch({
      type: ADD_SUBSECTION,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};
export const deleteSubSection =
  (quoteid, sectionid, subsectionid) => async (dispatch) => {
    await axios({
      method: "delete",
      url: `${API_URL}/api/quote/${quoteid}/section/${sectionid}/subsection/${subsectionid}`,
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => {
      dispatch({
        type: DELETE_SUBSECTION,
        data: {
          data: response.data,
          subsectionid: subsectionid,
          sectionid: sectionid,
        },
      });
      return Promise.resolve([]);
    });
  };
export const deleteUpdateQuoteState = () => async (dispatch) => {
  dispatch({
    type: DELETE_UPDATE_QUOTE_STATE,
  });
};
export const activateQuote = (quoteid) => async (dispatch) => {
  await axios({
    method: "put",
    url: `${API_URL}/api/quote/${quoteid}/activate`,
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => {
    dispatch({
      type: ACTIVATE_QUOTE,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};
export const FetchTeamProjectWise =
  (projectid, startdate, enddate) => async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchTeamProjectWise`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { projectid, startdate, enddate },
    }).then((response) => {
      dispatch({
        type: FETCH_TEAM_PROJECTWISE,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };
export const FetchTeams = () => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/FetchTeams`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {},
  }).then((response) => {
    dispatch({
      type: FETCH_TEAMS,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};
export const getEquipments =
  (companyId, pagerequire, pageNumber, querystring) => async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchEquiptmentByCompany`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        companyid: companyId,
        pagerequire: pagerequire,
        pagenumber: pageNumber,
        querystring: querystring,
      },
    }).then((response) => {
      dispatch({
        type: SET_EQUIPMENTS_DETAIL,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };

export const addEquipment = async (data) => {
  return await axios({
    method: "post",
    url: `${API_URL}/api/User/AddEquiptment`,
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  }).then((response) => {
    return response;
  });
};

export const deleteEquipment = async (id) => {
  return await axios({
    method: "post",
    url: `${API_URL}/api/User/DeleteEquiptment`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      equipmentid: id,
    },
  }).then((response) => {
    return response;
  });
};

export const fetchEquipment = async (id) => {
  return await axios({
    method: "post",
    url: `${API_URL}/api/User/FetchEquiptmentbyid`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      equipmentid: id,
    },
  }).then((response) => {
    return response.data.data[0];
  });
};
export const fetchDrivers = async (companyId) => {
  return await axios({
    method: "post",
    url: `${API_URL}/api/User/FetchDrivers`,
    headers: {
      "Content-Type": "application/json",
    },
    data: { companyid: companyId },
  }).then((response) => {
    return response;
  });
};
export const updateEquipment = async (data) => {
  return await axios({
    method: "post",
    url: `${API_URL}/api/User/UpdateEquiptment`,
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  }).then((response) => {
    return response;
  });
};

export const UpdatePOTaskStatus = (taskid) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/UpdatePOTaskStatus`,
    headers: {
      "Content-Type": "application/json",
    },
    data: { taskid },
  }).then((response) => {
    dispatch({
      type: UPDATE_PO_TASK_STATUS,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const AddTaskToTeam = (taskid, teams) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/AddTaskToTeam`,
    headers: {
      "Content-Type": "application/json",
    },
    data: { taskid, teams },
  }).then((response) => {
    dispatch({
      type: ADD_TASK_TO_TEAM,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const GetPOList = (quoteid) => (dispatch) => {
  axios({
    method: "get",
    url: `${API_URL}/api/quote/getpolist/${quoteid}`,
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => {
    dispatch({
      type: GET_PO_LIST,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const ApprovePO = (data) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/quote/approvepo`,
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  }).then((response) => {
    dispatch({
      type: APPROVE_PO,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const FetchInvoiceList =
  (companyid, sortby, querystring, statusFilter) => async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchInvoiceList`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        companyid: companyid,
        sortby: sortby,
        querystring: querystring,
        statusFilter: statusFilter,
      },
    }).then((response) => {
      dispatch({
        type: FETCH_INVOICE_ALL_LIST,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };

// export const FetchCreditInvoiceList = (companyid) => async (dispatch) => {
//   await axios({
//     method: "post",
//     url: `${API_URL}/api/User/FetchCreditInvoiceList`,
//     headers: {
//       "Content-Type": "application/json",
//     },
//     data: {
//       companyid: companyid,
//     },
//   }).then((response) => {
//     dispatch({
//       type: FETCH_CREDIT_INVOICE_ALL_LIST,
//       data: response.data,
//     });
//     return Promise.resolve([]);
//   });
// };

export const Fetchproduct_Parts_List = (payload) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/Fetchproduct/parts List`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {},
  }).then((response) => {
    dispatch({
      type: FETCH_PRODUCT_PART_LIST,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const AddInvoiceProject =
  (
    projectid,
    quoteid,
    companyid,
    invoicecode,
    ponumber,
    clientref,
    paymentdeadline,
    duedate,
    paymentoptions,
    invoicestatus,
    comment,
    totalexclusivebtw,
    totalinclusivebtw,
    invoicetotal,
    days,
    from,
    to,
    periodOfRecurrence,
    milestones,
  ) =>
  async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/User/AddInvoiceProject`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        projectid: projectid,
        quoteid: quoteid,
        companyid: companyid,
        invoicecode: invoicecode,
        ponumber: ponumber,
        clientref: clientref,
        paymentdeadline: paymentdeadline,
        duedate: duedate,
        paymentoptions: paymentoptions,
        invoicestatus: invoicestatus,
        comment: comment,
        totalexclusivebtw: totalexclusivebtw,
        totalinclusivebtw: totalinclusivebtw,
        invoicetotal: invoicetotal,
        days: days,
        from: from,
        to: to,
        periodOfRecurrence: periodOfRecurrence,
        milestones: milestones,
      },
    }).then((response) => {
      dispatch({
        type: ADD_INVOICE_PROJECT,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };

export const UpdateInvoiceProject =
  (
    invoiceid,
    projectid,
    quoteid,
    ponumber,
    clientref,
    paymentdeadline,
    paymentoptions,
    invoicestatus,
    comment,
    totalexclusivebtw,
    totalinclusivebtw,
    invoicetotal,
    duedate,
    days,
    from,
    to,
    periodOfRecurrence,
    milestones,
  ) =>
  async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/User/UpdateInvoiceProject`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        invoiceid: invoiceid,
        projectid: projectid,
        quoteid: quoteid,
        ponumber: ponumber,
        clientref: clientref,
        paymentdeadline: paymentdeadline,
        paymentoptions: paymentoptions,
        invoicestatus: invoicestatus,
        comment: comment,
        totalexclusivebtw: totalexclusivebtw,
        totalinclusivebtw: totalinclusivebtw,
        invoicetotal: invoicetotal,
        duedate: duedate,
        days: days,
        from: from,
        to: to,
        periodOfRecurrence: periodOfRecurrence,
        milestones: milestones,
      },
    }).then((response) => {
      dispatch({
        type: UPDATE_INVOICE_PROJECT,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };

export const FetchPaymentDeadline = (payload) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/FetchPaymentDeadline`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {},
  }).then((response) => {
    dispatch({
      type: FETCH_PAYMENT_DEADLINE,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const FetchInvoiceByInvoiceId = (invoiceid) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchInvoiceByInvoiceId`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { invoiceid: invoiceid },
    });
    dispatch({
      type: FETCH_INVOICE_BY_INVOICE_ID,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const FetchProjectByClient = (clientid) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/FetchProjectByClient`,
    headers: {
      "Content-Type": "application/json",
    },
    data: { clientid: clientid },
  }).then((response) => {
    dispatch({
      type: FETCH_PROJECT_BY_CLIENT,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const FetchProductByQuotes = (quoteid) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/FetchProductByQuotes`,
    headers: {
      "Content-Type": "application/json",
    },
    data: { quoteid: quoteid },
  }).then((response) => {
    dispatch({
      type: FETCH_PRODUCTS_BY_QUOTES,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const InvoiceDelete = (invoiceid) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/InvoiceDelete`,
    headers: {
      "Content-Type": "application/json",
    },
    data: { invoiceid: invoiceid },
  }).then((response) => {
    dispatch({
      type: INVOICE_DELETE,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const FetchLastInvoiceCode = (companyid) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/FetchLastInvoiceCode`,
    headers: {
      "Content-Type": "application/json",
    },
    data: { companyid: companyid },
  }).then((response) => {
    dispatch({
      type: FETCH_LAST_INVOICE_CODE,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const FetchInvoiceSettingList = (companyid) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/FetchInvoiceSettingList`,
    headers: {
      "Content-Type": "application/json",
    },
    data: { companyid, pagenumber: 0, pagerequire: 0 },
  }).then((response) => {
    dispatch({
      type: FETCH_INVOICE_SETTING_LIST,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const FetchMembers = (companyid) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/FetchActiveUsers`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      companyid: companyid,
    },
  }).then((response) => {
    dispatch({
      type: FETCH_MEMBERS,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const addTeam =
  (companyid, teamname, teamlogo, members) => async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/User/AddTeam`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        companyid,
        teamname,
        teamlogo,
        members,
      },
    }).then((response) => {
      dispatch({
        type: ADD_TEAM,
        data: response.data,
      });

      return Promise.resolve([]);
    });
  };

export const FetchTeamMemberByCompany =
  (companyid, pagerequire, pagenumber) => async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchTeamMemberByCompany`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        companyid,
        pagenumber,
        pagerequire,
      },
    }).then((response) => {
      dispatch({
        type: FETCH_TEAM_MEMBERS,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };

export const deleteTeamMember = (memberid) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/DeleteTeamMember`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      memberid,
    },
  }).then((response) => {
    dispatch({
      type: DELETE_TEAM_MEMBER,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const DeleteTeam = (teamid) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/DeleteTeam`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      teamid,
    },
  }).then((response) => {
    dispatch({
      type: DELETE_TEAM,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};
export const FetchInvoiceSettingByid =
  (invoiceSettingId) => async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchInvoiceSettingByid`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { invoiceSettingId },
    }).then((response) => {
      dispatch({
        type: FETCH_INVOICE_SETTING_BY_ID,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };
export const AddInvoiceSetting = (data) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/AddInvoiceSetting`,
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  }).then((response) => {
    dispatch({
      type: ADD_INVOICE_SETTING,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};
export const UpdateInvoiceSetting = (data) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/UpdateInvoiceSetting`,
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  }).then((response) => {
    dispatch({
      type: ADD_INVOICE_SETTING,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};
export const FetchTeam = (teamid) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/FetchTeamByTeamId`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      teamid,
    },
  }).then((response) => {
    dispatch({
      type: FETCH_TEAM,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const UpdateTeam =
  (teamid, teamlogo, tramname, members) => async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/User/UpdateTeam`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        teamid,
        teamlogo,
        tramname,
        members,
      },
    }).then((response) => {
      dispatch({
        type: UPDATE_TEAM,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };

export const FetchOrderPickingList =
  (companyid, sortby, type, querystring, pagerequire, pagenumber) =>
  async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchOrderPickingList`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        companyid: companyid,
        sortby: sortby,
        type: type,
        querystring: querystring,
        pagerequire: pagerequire,
        pagenumber: pagenumber,
      },
    }).then((response) => {
      dispatch({
        type: FETCH_ORDER_PICKING_LIST,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };

export const AddOrderPicking =
  (projectid, ordertotal, orderproductsqty) => async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/User/AddOrderPicking`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        projectid: projectid,
        ordertotal: ordertotal,
        orderproductsqty: orderproductsqty,
      },
    }).then((response) => {
      dispatch({
        type: ADD_ORDER_PICKING,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };
export const FetchCountStockReport =
  (startDate, endDate, pagerequire, pagenumber, query) => async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/User/CountStockReport`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        startDate: startDate,
        endDate: endDate,
        pagerequire: pagerequire,
        pagenumber: pagenumber,
        query: query,
      },
    }).then((response) => {
      dispatch({
        type: FETCH_COUNT_STOCK_REPORT,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };
export const FetchStockItemList =
  (sortby, type, querystring, pagerequire, pagenumber) => async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/User/ProductDropdown/ItemList`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        sortby: sortby,
        type: type,
        querystring: querystring,
        pagerequire: pagerequire,
        pagenumber: pagenumber,
      },
    }).then((response) => {
      dispatch({
        type: FETCH_STOCK_ITEM_LIST,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };
export const addCountStock = (payload) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/User/CountStock`,
    headers: {
      "Content-Type": "application/json",
    },
    data: payload,
  }).then((response) => {
    dispatch({
      type: ADD_TO_COUNT_STOCK,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};
export const DeleteCountStock = (payload) => (dispatch) => {
  axios({
    method: "delete",
    url: `${API_URL}/api/User/DeleteCountStock/${payload}`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {},
  }).then((response) => {
    dispatch({
      type: DELETE_COUNT_STOCK,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const QuoteExtraWorkValidation = (quoteid) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/User/QuoteExtraWorkValidation`,
    headers: {
      "Content-Type": "application/json",
    },
    data: { quoteid: quoteid },
  }).then((response) => {
    dispatch({
      type: QUOTE_EXTRAWORK_VALIDATION,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const FetchEquipmentByWeek =
  (companyid, startingdate, endingdate) => (dispatch) => {
    axios({
      method: "post",
      url: `${API_URL}/api/User/FetchEquipmentByWeek`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        companyid: companyid,
        startingdate: startingdate,
        endingdate: endingdate,
      },
    }).then((response) => {
      dispatch({
        type: FETCH_EQUIPMENT_BY_WEEK,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };

export const AddEquipmentToTask = (taskid, equipmentid) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/AddEquipmentToTask`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        taskid: taskid,
        equipmentid: equipmentid,
      },
    });
    dispatch({
      type: ADD_EQUIPMENT_TO_TASK,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: ADD_EQUIPMENT_TO_TASK,
      data: error.message,
    });
  }
};

export const FetchProvisional = (projectid) => (dispatch) => {
  axios({
    method: "get",
    url: `${API_URL}/api/quote/provisionals-sections/${projectid}`,
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => {
    dispatch({
      type: FETCH_PROVISIONAL,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const UpdateSupplierContactIndexPositions =
  (supplierContactid, indexPosition) => (dispatch) => {
    axios({
      method: "post",
      url: `${API_URL}/api/User/UpdateSupplierContactIndexPositions`,
      headers: {
        "Content-Type": "application/json",
      },
      data: supplierContactid,
      indexPosition,
    }).then((response) => {
      dispatch({
        type: UPDATE_SUPPLIER_CONTACT_POSITION,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };
export const fetchAssetList =
  ({ pageNumber, perPageRequired, sortby, query }) =>
  (dispatch) => {
    axios({
      method: "post",
      url: `${API_URL}/api/Asset/FetchAssetsList`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        sortby: sortby,
        querystring: query,
        pageNumber: pageNumber,
        perPageRequired: perPageRequired,
      },
    }).then((response) => {
      dispatch({
        type: FETCH_ASSET_LIST,
        data: response.data,
      });

      return Promise.resolve([]);
    });
  };
export const fetchAssetTreeList =
  ({ companyId }) =>
  (dispatch) => {
    axios({
      method: "post",
      url: `${API_URL}/api/Asset/FetchTreeAssets`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        companyid: companyId,
      },
    }).then((response) => {
      dispatch({
        type: FETCH_ASSET_TREE_LIST,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };

export const AddAssets = (data) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/Asset/AddAssets`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      data: data,
    },
  }).then((response) => {
    dispatch({
      type: ADD_ASSETS,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const FetchGroupList = (data) => (dispatch) => {
  axios({
    method: "GET",
    url: `${API_URL}/api/Asset/GroupList`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      data: data,
    },
  }).then((response) => {
    dispatch({
      type: FETCH_GROUP_LIST,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const fetchAssetByID =
  ({ assetId }) =>
  (dispatch) => {
    axios({
      method: "get",
      url: `${API_URL}/api/Asset/FetchAssetsById/${assetId}`,
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => {
      dispatch({
        type: FETCH_PARTICULAR_ASSET,
        data: response.data,
      });

      return Promise.resolve([]);
    });
  };

export const updateAsset = (payload) => (dispatch) => {
  axios({
    method: "put",
    url: `${API_URL}/api/Asset/UpdateAssets`,
    headers: {
      "Content-Type": "application/json",
    },
    data: payload,
  }).then((response) => {
    dispatch({
      type: UPDATE_ASSETS,
      data: payload,
    });
    return Promise.resolve([]);
  });
};

export const TurnUnvailable = async (data) => {
  try {
    const response = await axios.put(
      `${API_URL}/api/Asset/TurnUnavailibility`,
      data,
    );
    return response.data.data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const assetTypes = () => (dispatch) => {
  axios({
    method: "get",
    url: `${API_URL}/api/Asset/AssetTypes`,
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => {
    dispatch({
      type: ASSET_TYPES,
      data: response.data,
    });

    return Promise.resolve([]);
  });
};

export const deleteAsset = (assetId) => (dispatch) => {
  axios({
    method: "delete",
    url: `${API_URL}/api/Asset/DeleteAsset/${assetId}`,
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => {
    dispatch({
      type: DELETE_ASSET,
      data: response.data,
    });

    return Promise.resolve([]);
  });
};

export const FetchEquipmentPartList = () => (dispatch) => {
  axios({
    method: "GET",
    url: `${API_URL}/api/Asset/FacilityEquipipmentPartList`,
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => {
    dispatch({
      type: FETCH_EQUIPMENTPARTLIST,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const addSelectedPart = (part) => ({
  type: "ADD_SELECTED_PART",
  payload: part,
});

export const removeSelectedPart = (partId) => ({
  type: "REMOVE_SELECTED_PART",
  payload: partId,
});

export const updateSelectedPart = (part) => ({
  type: "UPDATE_SELECTED_PART",
  payload: part,
});

export const setSelectedParts = (parts) => ({
  type: "SET_SELECTED_PART",
  payload: parts,
});

export const deleteGroup = (groupId) => async (dispatch) => {
  await axios({
    method: "DELETE",
    url: `${API_URL}/api/Asset/group/delete/${groupId}`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      groupId,
    },
  }).then((response) => {
    dispatch({
      type: DELETE_GROUP,
      data: response,
    });
    return Promise.resolve([]);
  });
};

export const addGroup = (groupData) => {
  return async (dispatch) => {
    try {
      // Make API call to add a new group
      const response = await axios.post(
        `${API_URL}/api/Asset/group/add`,
        groupData,
      );
      // Dispatch success action or handle the response as needed
      dispatch({
        type: "ADD_GROUP_SUCCESS",
        payload: response.data, // You may adjust this based on your API response
      });
    } catch (error) {
      // Dispatch failure action or handle errors
      dispatch({
        type: "ADD_GROUP_FAILURE",
        payload: error.message,
      });
    }
  };
};

export const updateGroup = (updatedData) => async (dispatch) => {
  dispatch({ type: "UPDATE_GROUP" });
  try {
    // Make API call to update group data
    const response = await axios.put(
      `${API_URL}/api/Asset/group/update`,
      updatedData,
    );

    // Dispatch success action if API call is successful
    dispatch({
      type: "UPDATE_GROUP_SUCCESS",
      payload: response.data, // You may adjust this based on your API response
    });
  } catch (error) {
    // Dispatch failure action if API call encounters an error
    dispatch({
      type: "UPDATE_GROUP_FAILURE",
      payload: error.message,
    });
  }
};

export const FetchCategoryList = () => (dispatch) => {
  axios({
    method: "GET",
    url: `${API_URL}/api/Asset/CategoryList`,
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => {
    dispatch({
      type: FETCH_CATEGORY_LIST,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const FetchEquipmentList = () => (dispatch) => {
  axios({
    method: "GET",
    url: `${API_URL}/api/Asset/EquipmentPartList`,
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => {
    dispatch({
      type: FETCH_EQUIPMENT_LIST,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};
export const FetchAssetEquipmentAndPart = (supplierId) => (dispatch) => {
  axios({
    method: "POST",
    url: `${API_URL}/api/Asset/FetchEquipmentAndPart`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      supplierid: supplierId,
    },
  }).then((response) => {
    dispatch({
      type: FETCH_ASSET_EQUIPMENT_LIST,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};
export const IsActiveWidget = (companyid) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/FetchIsActiveWidged`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      companyid: companyid,
    },
  }).then((response) => {
    dispatch({
      type: IS_ACTIVE_WIDGET,
      data: response.data.data,
    });
    return Promise.resolve([]);
  });
};

export const ActiveWorker = (companyid) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/FetchActiveWorker`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      companyid: companyid,
    },
  }).then((response) => {
    dispatch({
      type: ACTIVE_WORKER,
      data: response.data.data,
    });
    return Promise.resolve([]);
  });
};

export const TopProject = (companyid) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/FetchTopTrackedProject`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      companyid: companyid,
    },
  }).then((response) => {
    dispatch({
      type: TOP_PROJECT,
      data: response.data.data,
    });
    return Promise.resolve([]);
  });
};

export const FetchTodayOnboardDetails = () => async (dispatch) => {
  await axios({
    method: "get",
    url: `${API_URL}/api/User/FetchTodayOnboardDetails`,
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => {
    dispatch({
      type: FETCH_TODAYONBOARDDETAILS,
      data: response.data.data,
    });
    return Promise.resolve([]);
  });
};

export const FetchInventory = () => async (dispatch) => {
  await axios({
    method: "get",
    url: `${API_URL}/api/Dashboard/Get365Inventory`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {},
  }).then((response) => {
    dispatch({
      type: FETCH_INVENTORY,
      data: response.data.data,
    });
    return Promise.resolve([]);
  });
};

export const fetchClientList = () => (dispatch) => {
  axios({
    method: "GET",
    url: `${API_URL}/api/Asset/ClientList`,
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => {
    dispatch({
      type: FETCH_CLIENT_LIST,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const fetchFacility = () => (dispatch) => {
  axios({
    method: "GET",
    url: `${API_URL}/api/Asset/FacilityList`,
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => {
    dispatch({
      type: FETCH_FACILITY_LIST,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const addAssetEquip = (assets) => {
  return async (dispatch) => {
    try {
      // Make API call to add a new group
      // const response = await axios.post(`${API_URL}/api/Asset/AddAssets`, assets);

      const response = await axios.post(
        `${API_URL}/api/Asset/AddAssets`,
        assets,
      );
      // Dispatch success action or handle the response as needed
      dispatch({
        type: "ADD_ASSETS_EQUIPMENT",
        payload: response.data, // You may adjust this based on your API response
      });
    } catch (error) {
      // Dispatch failure action or handle errors
      console.error(error);
    }
  };
};

export const CurrentWeekProjects = () => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/Dashboard/CurrentWeekProjects`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {},
  }).then((response) => {
    dispatch({
      type: WEEK_PROJECTS,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const ProjectCount = (companyId) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/Dashboard/LastAndCurrentWeekProjectCount`,
    headers: {
      "Content-Type": "application/json",
    },
    data: { companyId: companyId },
  }).then((response) => {
    dispatch({
      type: PROJECT_COUNT,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const AddDocumentToAsset = (payload) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/Files/AdddocumenttoAsset`,
    headers: {
      "Content-Type": "application/json",
    },
    data: payload,
  });
};
export const FetchDocumentByAssetById = (payload) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/Files/FetchddocumentbyAssetbyid`,
    headers: {
      "Content-Type": "application/json",
    },
    data: payload,
  }).then((response) => {
    dispatch({
      type: FETCH_DOCUMENT_BY_ASSETS_ID,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const DeleteAssetsDocument = (payload) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/Files/Deletedocument`,
    headers: {
      "Content-Type": "application/json",
    },
    data: payload,
  }).then((response) => {
    dispatch({
      type: DELETE_ASSETS_DOCUMENT,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const AddSupplierToAsset = (payload) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/Asset/AddSupplier`,
    headers: {
      "Content-Type": "application/json",
    },
    data: payload,
  });
};

export const AddInstructionsAsset = (payload) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/Asset/AddInstructions`,
    headers: {
      "Content-Type": "application/json",
    },
    data: payload,
  });
};

export const fetchInstructionsList = (id) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/Asset/FetchInstructions`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      assetId: id,
    },
  }).then((response) => {
    dispatch({
      type: FETCH_INSTRUCTIONS_LIST,
      data: response.data,
    });

    return Promise.resolve([]);
  });
};

export const DeleteInstructionsAsset =
  (assetAssemblyInstructionid) => (dispatch) => {
    axios({
      method: "post",
      url: `${API_URL}/api/Asset/DeleteInstructions`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        assetAssemblyInstructionid,
      },
    });
  };

export const UpdateInstructions = (payload) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/Asset/UpdateInstructions`,
    headers: {
      "Content-Type": "application/json",
    },
    data: payload,
  });
};

export const TurnUnavailable =
  (
    equipmentid,
    isavailable,
    isDefinitivelyUnavailable,
    isTemporaryUnavailable,
    reason,
    from,
    to,
  ) =>
  async (dispatch) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/User/TurnUnavailable`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        equipmentid: equipmentid,
        isavailable: isavailable,
        isDefinitivelyUnavailable: isDefinitivelyUnavailable,
        isTemporaryUnavailable: isTemporaryUnavailable,
        reason: reason,
        from: from,
        to: to,
      },
    }).then((response) => {
      dispatch({
        type: TURN_UNAVAILABLE,
        data: response.data,
      });
      return Promise.resolve([]);
    });
  };

export const FetchLast365InvoiceInsights = () => (dispatch) => {
  axios
    .get(`${API_URL}/api/dashboard/FetchInvoiceLast365DaysInsights`)
    .then((res) => {
      dispatch({
        type: LAST_365_INVOICE_INSIGHTS,
        data: res.data,
      });
    });
};

export const ModalList = (id) => (dispatch) => {
  axios({
    method: "get",
    url: `${API_URL}/api/Asset/ModalList`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {},
  }).then((response) => {
    dispatch({
      type: MODAL_LIST,
      data: response.data,
    });

    return Promise.resolve([]);
  });
};

export const ProductAndPartValidation = (partName) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/ProductAndPartValidation`,
    headers: {
      "Content-Type": "application/json",
    },
    data: { partName },
  }).then((response) => {
    dispatch({
      type: PRODUCT_AND_PART_VALIDATION,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const GlobalRequest = (obj) => async (dispatch) => {
  const { url, method, state, data } = obj;
  await axios({
    method,
    url,
    headers: {
      "Content-Type": "application/json",
    },
    data: { ...data },
  }).then((response) => {
    dispatch({
      type: GLOBAL_REQUEST,
      data: { response: response.data, state2: state },
    });
    return Promise.resolve([]);
  });
};

export const invoiceSendEmail = (to) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/SendEmail`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      subject: "Successfully Mail Send To Supplier",
      to: to,
      eventid: "08dc57cc-9bed-42f1-8a72-4a766eaf2003",
      name: "spire solution",
    },
  }).then((response) => {
    dispatch({
      type: INVOICE_SEND_EMAIL,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const invoiceSendEmailCount = (companyid) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/FetchInvoicePDFCount`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      companyid,
    },
  }).then((response) => {
    dispatch({
      type: INVOICE_SEND_EMAIL_COUNT,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const FetchLastCreditInvoiceCode = (companyid) => async (dispatch) => {
  await axios({
    method: "post",
    url: `${API_URL}/api/User/FetchLastCreditInvoiceCode`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      companyid,
    },
  }).then((response) => {
    dispatch({
      type: FETCH_LAST_CREDIT_INVOICE_CODE,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

// export const InvoiceGeneratePDF =
//   (invoiceid, clientname) => async (dispatch) => {
//     try {
//       const response = await axios({
//         method: "get",
//         url: `${API_URL}/api/Files/FetchInvoicePdfData/${invoiceid}`,
//         responseType: "blob",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         // data: {},
//       });
//       if (response.status === 200) {
//         const downloadLink = document.createElement("a");
//         downloadLink.href = URL.createObjectURL(response.data);
//         // downloadLink.download = `PO_${ordercode.replace(".", "/")}.pdf`;
//         downloadLink.download = `Invoice of ${clientname}.pdf`;
//         // downloadLink.download = `Invoice of ${clientname}.docx`;
//         downloadLink.click();
//       }
//       dispatch({
//         type: INVOICE_GENRATE_PDF,
//         data: response.data,
//       });
//       return response.data;
//     } catch (error) {
//       console.error(error);
//     }
//   };

export const InvoiceGeneratePDF = (invoiceid, template) => async (dispatch) => {
  let apiUrl = `${API_URL}/api/Files/FetchInvoicePdfData/${invoiceid}`;
  if (template) {
    apiUrl += `/${template}`;
  }
  try {
    const response = await axios({
      method: "get",
      url: apiUrl,
      headers: {
        "Content-Type": "application/json",
      },
      data: {},
    });
    dispatch({
      type: INVOICE_GENRATE_PDF,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const FetchTasksWithOutProject = (companyid) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchTasksWithOutProject`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { companyid },
    });
    dispatch({
      type: FETCH_TASK_WITHOUT_PROJECT,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const UpdateWarehouseOrderProject =
  (orderid, projectid) => async (dispatch) => {
    try {
      const response = await axios({
        method: "post",
        url: `${API_URL}/api/User/UpdateWarehouseOrderProject`,
        headers: {
          "Content-Type": "application/json",
        },
        data: { orderid, projectid },
      });
      dispatch({
        type: UPDATE_WAREHOUSE_ORDER_PROJECT,
        data: response.data,
      });
      return response.data;
    } catch (error) {
      console.error(error);
    }
  };

export const FetchProductPartCategories = (querystring) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/Stocks/FetchProductPartCategories`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { querystring },
    });
    dispatch({
      type: FETCH_PRODUCT_PART_CATEGORIES,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const FetchAssetPurchasingOrderByID =
  (assetPurchasingOrderid) => async (dispatch) => {
    try {
      const response = await axios({
        method: "post",
        url: `${API_URL}/api/Asset/FetchAssetPurchasingOrderByID`,
        headers: {
          "Content-Type": "application/json",
        },
        data: { assetPurchasingOrderid },
      });
      dispatch({
        type: FETCH_ASSET_PURCHASING_ORDER_BY_ID,
        data: response.data,
      });
      return response.data;
    } catch (error) {
      console.error(error);
    }
  };

// for stock filter list start.
export const FetchProductFilterList = (payload) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/User/FetchProduct/PartByCompany`,
    headers: {
      "Content-Type": "application/json",
    },
    data: payload,
  }).then((response) => {
    dispatch({
      type: FETCH_PRODUCT_STOCK_FILTER_LIST,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};
// for stock filter list end.

export const SendInvoice =
  (invoiceId, clientEmail, invoiceNumber, link, templateId) =>
  async (dispatch) => {
    try {
      const response = await axios({
        method: "post",
        url: `${API_URL}/api/User/SendInvoice`,
        headers: {
          "Content-Type": "application/json",
        },
        data: { invoiceId, clientEmail, invoiceNumber, link, templateId },
      });
      dispatch({
        type: SEND_INVOICE_EMAIL,
        data: response.data,
      });
      return response.data;
    } catch (error) {
      console.error(error);
    }
  };

export const GetSendInvoiceCount = (InvoiceId) => async (dispatch) => {
  try {
    const response = await axios({
      method: "get",
      url: `${API_URL}/api/User/GetSendInvoiceCount/${InvoiceId}`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {},
    });
    dispatch({
      type: SEND_INVOICE_EMAIL_COUNT,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const UpdateFileUploading = (isUploading) => async (dispatch) => {
  dispatch({ type: "UPDATE_FILE_UPLOADING", data: isUploading });
};

export const userVerifySignup = (userid) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/VerifySignup`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        userid,
        isverified: 1,
      },
    });
    dispatch({
      type: USER_VERIFICATION,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const syncToQuickBooks = () => async (dispatch) => {
  dispatch({ type: UPDATE_SYNC_QB_STATUS, data: "INPROGRESS" });
  axios
    .get(`${API_URL}/api/Dashboard/SyncToQuickBooks`)
    .then((resp) => {
      dispatch({
        type: UPDATE_SYNC_QB_STATUS,
        data: "SUCCESS",
        response: resp.data,
      });
    })
    .catch(() => {
      dispatch({ type: UPDATE_SYNC_QB_STATUS, data: "FAILED" });
    });
};

export const fetchProjectCostDetailsByProjectId = (projectid) => (dispatch) => {
  axios
    .post(`${API_URL}/api/Quote/GetCostDetailsOfProject/${projectid}`)
    .then((response) => {
      dispatch({
        type: PROJECT_COST_DETAILS,
        data: response.data,
      });
    });
};

export const DeleteComments = (commentid) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/DeleteComments`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { commentid },
    });
    dispatch({
      type: TASK_MODAL_COMMENT_DELETE,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const AddBillingInformation =
  (
    companyname,
    address,
    companyEmail,
    contactname,
    contactEmail,
    vaTnumber,
    addressParts = {},
  ) =>
  async (dispatch) => {
    try {
      const response = await axios({
        method: "post",
        url: `${API_URL}/api/Company/AddBillingInformation`,
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          companyname,
          address,
          companyEmail,
          contactname,
          contactEmail,
          vaTnumber,
          street: addressParts.street || "",
          city: addressParts.city || "",
          state: addressParts.state || "",
          pinCode: addressParts.pinCode || "",
          country: addressParts.country || "",
        },
      });
      dispatch({
        type: ADD_BILLING_INFORMATION,
        data: response.data,
      });
      return response.data;
    } catch (error) {
      console.error(error);
    }
  };

export const UpdateBillingInformation =
  (
    billingInformationid,
    companyname,
    address,
    companyEmail,
    contactname,
    contactEmail,
    vaTnumber,
    addressParts = {},
  ) =>
  async (dispatch) => {
    try {
      const response = await axios({
        method: "post",
        url: `${API_URL}/api/Company/UpdateBillingInformation`,
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          billingInformationid,
          companyname,
          address,
          companyEmail,
          contactname,
          contactEmail,
          vaTnumber,
          street: addressParts.street || "",
          city: addressParts.city || "",
          state: addressParts.state || "",
          pinCode: addressParts.pinCode || "",
          country: addressParts.country || "",
        },
      });
      dispatch({
        type: UPDATE_BILLING_INFORMATION,
        data: response.data,
      });
      return response.data;
    } catch (error) {
      console.error(error);
    }
  };

export const FetchBillingInformation =
  (billingInformationid) => async (dispatch) => {
    try {
      const response = await axios({
        method: "post",
        url: `${API_URL}/api/Company/FetchBillingInformation`,
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          billingInformationid,
        },
      });
      dispatch({
        type: FETCH_BILLING_INFORMATION,
        data: response.data,
      });
      return response.data;
    } catch (error) {
      console.error(error);
    }
  };

export const FetchIndustry = () => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/Company/FetchIndustry`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {},
    });
    dispatch({
      type: FETCH_INDUSTRY,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const AddIndustryToCompany = (type, industryId) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/Company/AddIndustryToCompany`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        type,
        industryId,
      },
    });
    dispatch({
      type: ADD_INDUSTRY_TO_COMPANY,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const sendApprovedQuotesEmail = (quoteId, email) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/quote/send-email`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        quoteId,
        email,
      },
    });
    dispatch({
      type: SEND_APPROVED_QUOTES_EMAIL,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const OcrProcessDocument = (file) => async (dispatch) => {
  let requestHeaders = { headers: { "Content-Type": "multipart/form-data" } };
  let formdata = new FormData();
  formdata.append("file", file);
  const response = await axios.post(
    `${API_URL}/api/Ocr/process`,
    formdata,
    requestHeaders,
  );
  if (response.data && response.data?.status) {
    dispatch({ type: OCR_PROCESSED_DOCUMENT, data: response.data.data });
  }
};

export const OcrDocumentSave = (payload) => async (dispatch) => {
  const response = await axios.post(`${API_URL}/api/Ocr/save`, payload);
  if (response.status == 200) {
    dispatch({ type: OCR_DOCUMENT_SAVED, data: true });
  }
};

export const OcrDocumentUpdate = (payload) => async (dispatch) => {
  const response = await axios.post(`${API_URL}/api/Ocr/update`, payload);
  if (response.status == 200) {
    dispatch({ type: OCR_DOCUMENT_SAVED, data: true });
  }
};

export const OcrGetAllOCRDocuments = (payload) => async (dispatch) => {
  const response = await axios.post(`${API_URL}/api/Ocr/documents`, payload);
  if (response.status == 200 && response.data?.status) {
    dispatch({ type: OCR_FETCH_ALL_DOCUMENTS, data: response.data });
  }
};

export const OcrDocumentAccept = (documentid) => async (dispatch) => {
  const response = await axios.post(
    `${API_URL}/api/Ocr/document/${documentid}/accept`,
  );
  if (response.status == 200 && response.data?.status) {
    dispatch({ type: OCR_DOCUMENT_ACCEPT, data: response.data });
  }
};

export const OcrDocumentDuplicate = (documentid) => async (dispatch) => {
  const response = await axios.post(
    `${API_URL}/api/Ocr/document/${documentid}/duplicate`,
  );
  if (response.status == 200 && response.data?.status) {
    dispatch({ type: OCR_DOCUMENT_DUPLICATE, data: response.data });
  }
};

export const OcrDocumentDelete = (documentid) => async (dispatch) => {
  const response = await axios.delete(
    `${API_URL}/api/Ocr/document/${documentid}`,
  );
  if (response.status == 200 && response.data?.status) {
    dispatch({ type: OCR_DOCUMENT_DELETE, data: response.data });
  }
};

export const OcrGetOcrDocumentById = (documentid) => async (dispatch) => {
  const response = await axios.get(`${API_URL}/api/Ocr/document/${documentid}`);
  if (response.status == 200 && response.data?.status) {
    dispatch({ type: OCR_DOCUMENT_BY_ID, data: response.data?.data });
  }
};

export const ClearOcrTempData = () => (dispatch) => {
  dispatch({ type: OCR_DOCUMENT_SAVED, data: false });
  dispatch({ type: OCR_PROCESSED_DOCUMENT, data: {} });
  dispatch({ type: OCR_DOCUMENT_BY_ID, data: {} });
};

// ASC REDUX PROPS START //
export const PO_Supplier_Props_API = (poSupplierName, poSupplierID) => {
  return {
    type: PO_SUPPLIER_PROPS_API,
    data: { poSupplierName, poSupplierID },
  };
};
// ASC REDUX PROPS END //

export const AddForm = (body) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/Form/AddForm`,
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
    });
    dispatch({
      type: ADD_FORM,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const AddFormSections = (formId, sectionname) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/Company/AddFormSections`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        formId,
        sectionname,
      },
    });
    dispatch({
      type: ADD_FORM_SECTION,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const FetchClientsByCompany =
  (querystring, filter) => async (dispatch) => {
    try {
      const response = await axios({
        method: "post",
        url: `${API_URL}/api/User/FetchClientsByCompany`,
        headers: {
          "Content-Type": "application/json",
        },
        data: { querystring, filter },
      });
      dispatch({
        type: FETCH_CLIENTS_BY_COMPANY,
        data: response.data,
      });
      return response.data;
    } catch (error) {
      console.error(error);
    }
  };

export const fetchFormList = () => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/Form/FetchFormList`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {},
    });
    dispatch({
      type: FETCH_FORM_LIST,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const FetchFormListForWorkflow = () => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/Form/FetchFormListForWorkflow`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {},
    });
    dispatch({
      type: FETCH_WORKFLOW_FORM_LIST,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const fetchFormById = (formId) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/Form/FetchFormById`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { formId },
    });
    dispatch({
      type: FETCH_FORM_BY_ID,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const fetchTemplateForms = () => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/Form/FetchTemplateForms`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {},
    });
    dispatch({
      type: FETCH_TEMPLATE_FORMS,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const deleteForm = (formId) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/Form/DeleteForm`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { formId },
    });
    dispatch({
      type: DELETE_FORM,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const updateForm = (body) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/Form/UpdateForm`,
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
    });
    dispatch({
      type: UPDATE_FORM,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const AddPersonalTask = (taskname, duedatetime) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/AddPersonalTask`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { taskname, duedatetime },
    });
    dispatch({
      type: ADD_PERSONAL_TASK,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const FetchPersonalTask = () => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchPersonalTask`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {},
    });
    dispatch({
      type: FETCH_PERSONAL_TASK,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const FetchUserIntegration = () => async (dispatch) => {
  try {
    const response = await axios({
      method: "get",
      url: `${API_URL}/api/User/GetIntegrationSettings`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {},
    });
    dispatch({
      type: FETCH_INTERGRATION,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const UpdateIsCheckPersonalTask =
  (duedatetime, taskid, isCheck) => async (dispatch) => {
    try {
      const response = await axios({
        method: "post",
        url: `${API_URL}/api/User/UpdateIsCheckPersonalTask`,
        headers: {
          "Content-Type": "application/json",
        },
        data: { duedatetime, taskid, isCheck },
      });
      dispatch({
        type: UPDATE_ISCHECK_PERSONAL_TASK,
        data: response.data,
      });
      return response.data;
    } catch (error) {
      console.error(error);
    }
  };

export const SetSpireConnectionToken = (token) => async (dispatch) => {
  try {
    const expiryDate = new Date();
    expiryDate.setDate(new Date().getDate() + 180);

    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/IntegrationSettings/AddSpireToken`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        integrationToken: token,
        tokenValidity: "180 Days",
        tokenExpiryDate: expiryDate,
      },
    });
  } catch (error) {
    console.error(error);
  }
};

export const SetQuickBookConnection = () => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/IntegrationSettings/AddQuickBookToken`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        integrationToken: "",
        tokenValidity: "",
        tokenExpiryDate: new Date().toLocaleString(),
      },
    });
  } catch (error) {
    console.error(error);
  }
};

export const templateTypes = () => (dispatch) => {
  axios({
    method: "get",
    url: `${API_URL}/api/TemplateBuilder/TemplateTypes`,
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => {
    dispatch({
      type: TEMPLATE_TYPES,
      data: response.data,
    });

    return Promise.resolve([]);
  });
};

export const availableTemplates = () => (dispatch) => {
  axios({
    method: "get",
    url: `${API_URL}/api/TemplateBuilder/AvailableTemplates`,
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => {
    dispatch({
      type: AVAILABLE_TEMPLATES,
      data: response.data,
    });

    return Promise.resolve([]);
  });
};

export const availabaleFields = () => (dispatch) => {
  axios({
    method: "get",
    url: `${API_URL}/api/TemplateBuilder/AvailableFields`,
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => {
    dispatch({
      type: TEMPLATE_BUILDER_AVAILABLE_FIELDS,
      data: response.data,
    });

    return Promise.resolve([]);
  });
};

export const addNewInvoiceTemplate = (data) => {
  return axios({
    method: "post",
    url: `${API_URL}/api/TemplateBuilder/AddNewInvoice`,
    headers: {
      "Content-Type": "application/json",
    },
    data,
  });
};

export const addNewStockTemplate = (data) => {
  return axios({
    method: "post",
    url: `${API_URL}/api/TemplateBuilder/AddNewStock`,
    headers: {
      "Content-Type": "application/json",
    },
    data,
  });
};

export const addNewEmailTemplate = (data) => {
  return axios({
    method: "post",
    url: `${API_URL}/api/TemplateBuilder/AddNewEmail`,
    headers: {
      "Content-Type": "application/json",
    },
    data,
  });
};

export const addNewCheckListTemplate = (data) => {
  return axios({
    method: "post",
    url: `${API_URL}/api/TemplateBuilder/AddNewCheckList`,
    headers: {
      "Content-Type": "application/json",
    },
    data,
  });
};

export const addNewOthersTemplate = (data) => {
  return axios({
    method: "post",
    url: `${API_URL}/api/TemplateBuilder/AddNewOther`,
    headers: {
      "Content-Type": "application/json",
    },
    data,
  });
};

export const addNewQuotesTemplate = (data) => {
  return axios({
    method: "post",
    url: `${API_URL}/api/TemplateBuilder/AddNewQuote`,
    headers: {
      "Content-Type": "application/json",
    },
    data,
  });
};

export const getTemplateForEditById = (templateId) => {
  return axios({
    method: "get",
    url: `${API_URL}/api/TemplateBuilder/EditTemplate/${templateId}`,
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const EditTemplate = (templateId, data) => {
  return axios({
    method: "put",
    url: `${API_URL}/api/TemplateBuilder/EditTemplate/${templateId}`,
    headers: {
      "Content-Type": "application/json",
    },
    data,
  });
};

export const deleteTemplateById = (templateId) => {
  return axios({
    method: "delete",
    url: `${API_URL}/api/TemplateBuilder/DeleteTemplate/${templateId}`,
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const fetchFormsByProject = (projectId) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/Form/FetchProjectForm`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { projectId },
    });
    dispatch({
      type: FETCH_FORM_BY_PROJECT,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const linkFormToProject = (body) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/Form/LinkProjectToForm`,
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
    });
    dispatch({
      type: LINK_FORM_BY_PROJECT,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const unlinkFormToProject = (body) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/Form/UNLinkProjectToForm`,
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
    });
    dispatch({
      type: UNLINK_FORM_BY_PROJECT,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const linkTaskToForm = (body) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/Form/LinkTaskToForm`,
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
    });
    dispatch({
      type: LINK_TASK_BY_FORM,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const FetchUserMAXAmount = () => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchUserMAXAmount`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {},
    });
    dispatch({
      type: FETCH_USER_MAX_AMOUNT,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const UpdateUserMaxAmount = (userMaxAmount) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/UpdateUserMaxAmount`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { userMaxAmount },
    });
    dispatch({
      type: UPDATE_USER_MAX_AMOUNT,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const ApproveOrder = (approveAwaitingOrder) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/ApproveOrder`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { approveAwaitingOrder },
    });
    dispatch({
      type: APPROVED_ORDER,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const FetchProjectBillingTerms = () => async (dispatch) => {
  try {
    const response = await axios({
      method: "get",
      url: `${API_URL}/api/User/FetchProjectBillingTerms`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {},
    });
    dispatch({
      type: FETCH_PROJECT_BILLING_TERMS,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const AddNewClient =
  (
    companyName,
    clientDescription,
    streetNameNumber,
    companyImage,
    mainCompanyType,
    zipcode,
    city,
    country,
    isActive,
    basicInformation,
    generalInformation,
    financialInformation,
    addressParts = {},
  ) =>
  async (dispatch) => {
    try {
      const response = await axios({
        method: "post",
        url: `${API_URL}/api/Company/AddNewClient`,
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          companyName,
          clientDescription,
          streetNameNumber,
          companyImage,
          mainCompanyType,
          zipcode,
          city,
          country,
          isActive,
          basicInformation,
          generalInformation,
          financialInformation,
          street: addressParts.street || "",
          state: addressParts.state || "",
          pinCode: addressParts.pinCode || "",
        },
      });
      dispatch({
        type: ADD_NEW_CLIENT,
        data: response.data,
      });
      return response.data;
    } catch (error) {
      console.error(error);
    }
  };

export const UpdateClient =
  (
    clientId,
    companyName,
    streetNameNumber,
    companyImage,
    mainCompanyType,
    zipcode,
    city,
    country,
    isActive,
    basicInformation,
    generalInformation,
    financialInformation,
    addressParts = {},
  ) =>
  async (dispatch) => {
    try {
      const response = await axios({
        method: "put",
        url: `${API_URL}/api/Company/UpdateClient`,
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          clientId,
          companyName,
          streetNameNumber,
          companyImage,
          mainCompanyType,
          zipcode,
          city,
          country,
          isActive,
          basicInformation,
          generalInformation,
          financialInformation,
          street: addressParts.street || "",
          state: addressParts.state || "",
          pinCode: addressParts.pinCode || "",
        },
      });
      dispatch({
        type: UPDATE_CLIENT_COMPANY,
        data: response.data,
      });
      return response.data;
    } catch (error) {
      console.error(error);
    }
  };

export const UpdateClientDetails =
  (
    clientId,
    companyName,
    clientDescription,
    streetNameNumber,
    companyImage,
    mainCompanyType,
    zipcode,
    city,
    country,
    isActive,
    basicInformation,
    generalInformation,
    financialInformation,
    addressParts = {},
  ) =>
  async (dispatch) => {
    try {
      const response = await axios({
        method: "post",
        url: `${API_URL}/api/Company/UpdateClientDetails`,
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          clientId,
          companyName,
          clientDescription,
          streetNameNumber,
          companyImage,
          mainCompanyType,
          zipcode,
          city,
          country,
          isActive,
          basicInformation,
          generalInformation,
          financialInformation,
          street: addressParts.street || "",
          state: addressParts.state || "",
          pinCode: addressParts.pinCode || "",
        },
      });
      dispatch({
        type: UPDATE_CLIENT_DETAILS,
        data: response.data,
      });
      return response.data;
    } catch (error) {
      console.error(error);
    }
  };

export const FetchClientById = (clientId) => async (dispatch) => {
  try {
    const response = await axios({
      method: "get",
      url: `${API_URL}/api/Company/FetchClientById/${clientId}`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {},
    });
    dispatch({
      type: FETCH_CLIENT_BY_ID,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const ClientAddressCheck = (address) => async (dispatch) => {
  try {
    const response = await axios({
      method: "put",
      url: `${API_URL}/api/Company/ClientAddressCheck`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { address },
    });
    dispatch({
      type: EXISTING_COMPANY_ADDRESS,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const DeleteMultipleAddress = (ids) => async (dispatch) => {
  try {
    const response = await axios({
      method: "put",
      url: `${API_URL}/api/Company/DeleteMultipleAddress`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { ids },
    });
    dispatch({
      type: DELETE_MULTIPLE_ADDRESS,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const FetchClientContactsByclientId = (clientId) => async (dispatch) => {
  try {
    const response = await axios({
      method: "get",
      url: `${API_URL}/api/Company/FetchClientContactsByclientId/${clientId}`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {},
    });
    dispatch({
      type: FETCH_CLIENT_CONTACTS_BY_CLIENT_ID,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const FetchClientTasks = (clientId, projectId) => async (dispatch) => {
  try {
    const response = await axios({
      method: "get",
      url: `${API_URL}/api/Company/FetchClientTasks/${clientId}/${projectId}`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {},
    });
    dispatch({
      type: FETCH_CLIENT_TASKS,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const ClientActivityTimeline =
  (clientId, activityType) => async (dispatch) => {
    try {
      const response = await axios({
        method: "post",
        url: `${API_URL}/api/Company/ClientActivityTimeline`,
        headers: {
          "Content-Type": "application/json",
        },
        data: { clientId, activityType },
      });
      dispatch({
        type: CLIENT_ACTIVITY_TIMELINE,
        data: response.data,
      });
      return response.data;
    } catch (error) {
      console.error(error);
    }
  };

export const GetCreditTypeForDropdown = () => async (dispatch) => {
  try {
    const response = await axios({
      method: "get",
      url: `${API_URL}/api/Company/GetCreditTypeForDropdown`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {},
    });
    dispatch({
      type: GET_CREDIT_TYPE_DROPDOWN,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const GetInvoiceTypeForDropdown = () => async (dispatch) => {
  try {
    const response = await axios({
      method: "get",
      url: `${API_URL}/api/Company/GetInvoiceTypeForDropdown`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {},
    });
    dispatch({
      type: GET_INVOICE_TYPE_DROPDOWN,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const GetDiscountTypeForDropdown = () => async (dispatch) => {
  try {
    const response = await axios({
      method: "get",
      url: `${API_URL}/api/Company/GetDiscountTypeForDropdown`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {},
    });
    dispatch({
      type: GET_DISCOUNT_TYPE_DROPDOWN,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const AddDiscount = () => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/Company/AddDiscount`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {},
    });
    dispatch({
      type: ADD_DISCOUNT,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const DeleteClientcontact = (contactId) => async (dispatch) => {
  try {
    const response = await axios({
      method: "delete",
      url: `${API_URL}/api/Company/DeleteClientcontact/${contactId}`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {},
    });
    dispatch({
      type: DELETE_CLIENT_CONTACT,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const fetchIdsType = () => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchIDsType`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {},
    });
    dispatch({
      type: FETCH_ID_TYPE,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const fetchEmployeeType = () => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchEmployeeType`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {},
    });
    dispatch({
      type: FETCH_EMPLOYEETYPE,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const fetchContractType = () => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchContractType`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {},
    });
    dispatch({
      type: FETCH_CONTRACT_TYPE,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const fetchCompanyCar = () => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchCompanyCar`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {},
    });
    dispatch({
      type: FETCH_COMPANY_CAR,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const fetchReasons = () => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchReasons`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {},
    });
    dispatch({
      type: FETCH_REASONS,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const fetchUserCertification = () => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchUserCertification`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {},
    });
    dispatch({
      type: FETCH_USER_CERTIFICATION,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const insertDocToS3 = () => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/InsertDocToS3`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {},
    });
    dispatch({
      type: INSERT_DOC_TO_S3,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const quoteProductState = (data) => async (dispatch) => {
  dispatch({
    type: "QUOTE_PRODUCTS_STATE",
    data,
  });
};

export const SendEmailforRegistering = (companyid, to) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/User/SendEmail`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      companyid: companyid,
      subject: "Successfully Registered",
      to: to,
      eventid: "08dc57cc-9bed-42f1-8a72-4a766eaf2001",
      name: "spire solution",
    },
  }).then((response) => {
    dispatch({
      type: SEND_EMAIL_REGISTRATION,
      data: response.data,
    });
    return Promise.resolve([]);
  });
};

export const emptyAddQuoteState = () => (dispatch) => {
  dispatch({
    type: "EMPTY_ADD_QUOTES_STATE",
    data: {},
  });
};

export const updateAndDeleteCompanyCar = (body) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/User/Update/DeleteCompanyCar`,
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
  })
    .then((response) => {
      dispatch({
        type: UPDATE_DELETE_COMPANY_CAR,
        data: response.data,
      });
      return Promise.resolve([]);
    })
    .then(() => dispatch(fetchCompanyCar()));
};

export const updateAndDeleteContractType = (body) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/User/Update/DeleteContractType`,
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
  })
    .then((response) => {
      dispatch({
        type: UPDATE_DELETE_CONTRACT_TYPE,
        data: response.data,
      });
      return Promise.resolve([]);
    })
    .then(() => dispatch(fetchContractType()));
};

export const updateAndDeleteEmployeeType = (body) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/User/Update/DeleteEmployeeType`,
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
  })
    .then((response) => {
      dispatch({
        type: UPDATE_DELETE_EMPLOYEE_TYPE,
        data: response.data,
      });
      return Promise.resolve([]);
    })
    .then(() => dispatch(fetchEmployeeType()));
};

export const updateAndDeleteIdsType = (body) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/User/Update/DeleteIDsType`,
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
  })
    .then((response) => {
      dispatch({
        type: UPDATE_DELETE_ID_TYPE,
        data: response.data,
      });
      return Promise.resolve([]);
    })
    .then(() => dispatch(fetchIdsType()));
};

export const updateAndDeleteReasons = (body) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/User/Update/DeleteReasons`,
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
  })
    .then((response) => {
      dispatch({
        type: UPDATE_DELETE_REASONS,
        data: response.data,
      });
      return Promise.resolve([]);
    })
    .then(() => dispatch(fetchReasons()));
};

//   DELETE_COMPANY_CAR ,
//  DELETE_CONTRACT_TYPE,
// DELETE_EMPLOYEE_TYPE,
//  DELETE_ID_TYPE ,
// DELETE_REASONS ,

export const deleteCompanyCar = (id) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/User/DeleteCompanyCar`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      companyCarId: id,
    },
  })
    .then((response) => {
      dispatch({
        type: DELETE_COMPANY_CAR,
        data: response.data,
      });
      return Promise.resolve([]);
    })
    .then(() => dispatch(fetchCompanyCar()));
};

export const deleteContractType = (id) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/User/DeleteContractType`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      contractTypeId: id,
    },
  })
    .then((response) => {
      dispatch({
        type: DELETE_CONTRACT_TYPE,
        data: response.data,
      });
      return Promise.resolve([]);
    })
    .then(() => dispatch(fetchContractType()));
};

export const deleteEmployeeType = (id) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/User/DeleteEmployeeType`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      employeeTypeId: id,
    },
  })
    .then((response) => {
      dispatch({
        type: DELETE_EMPLOYEE_TYPE,
        data: response.data,
      });
      return Promise.resolve([]);
    })
    .then(() => dispatch(fetchEmployeeType()));
};

export const deleteIdsType = (id) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/User/DeleteIDsType`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      idsTypeid: id,
    },
  })
    .then((response) => {
      dispatch({
        type: DELETE_ID_TYPE,
        data: response.data,
      });
      return Promise.resolve([]);
    })
    .then(() => dispatch(fetchIdsType()));
};

export const deleteReasons = (id) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/User/DeleteReasons`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      reasonid: id,
    },
  })
    .then((response) => {
      dispatch({
        type: DELETE_REASONS,
        data: response.data,
      });
      return Promise.resolve([]);
    })
    .then(() => dispatch(fetchReasons()));
};

export const addFormResponse = (response) => (dispatch) => {
  axios({
    method: "post",
    url: `${API_URL}/api/Form/AddFormResponse`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      formResponse: response,
    },
  })
    .then((response) => {
      dispatch({
        type: ADD_FORM_RESPONSE,
        data: response.data,
      });
      return Promise.resolve([]);
    })
    .then(() => dispatch(fetchReasons()));
};

export const QuotesGeneratePDF = (quoteid, template) => async (dispatch) => {
  let apiUrl = `${API_URL}/api/quote/FetchQuotePdfData/${quoteid}`;
  //let apiUrl = `${API_URL}/api/quote/${quoteid}/pdf`;
  if (template) {
    apiUrl += `/${template}`;
  }
  try {
    const response = await axios({
      method: "get",
      url: apiUrl,
      headers: {
        "Content-Type": "application/json",
      },
      data: {},
    });
    dispatch({
      type: QUOTE_GENRATE_PDF,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const FetchProjectWorks =
  (projectid, filter, pagerequire, pagenumber) => async (dispatch) => {
    try {
      const response = await axios({
        method: "post",
        url: `${API_URL}/api/User/FetchProjectWorks`,
        headers: {
          "Content-Type": "application/json",
        },
        data: { projectid, filter, pagerequire, pagenumber },
      });
      dispatch({
        type: FETCH_PROJECT_WORKS,
        data: response.data,
      });
      return response.data;
    } catch (error) {
      console.error(error);
    }
  };

export const DeleteWork = (workid) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/DeleteWork`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { workid },
    });
    dispatch({
      type: DELETE_WORK_LIST,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const AddWorkTask =
  (workname, projectid, supervisorid, workTask) => async (dispatch) => {
    try {
      const response = await axios({
        method: "post",
        url: `${API_URL}/api/User/AddWorkTask`,
        headers: {
          "Content-Type": "application/json",
        },
        data: { workname, projectid, supervisorid, workTask },
      });
      dispatch({
        type: ADD_WORK_TASK,
        data: response.data,
      });
      return response.data;
    } catch (error) {
      console.error(error);
    }
  };

export const DeleteWorkTask = (workTaskid) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/DeleteWorkTask`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { workTaskid },
    });
    dispatch({
      type: DELETE_WORK_TASK,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const FetchWorkById = (workid) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchWorkById`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { workid },
    });
    dispatch({
      type: FETCH_WORK_TASK_BY_ID,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const UpdateWorkTask =
  (workid, projectid, workname, supervisorid, workTasks) =>
  async (dispatch) => {
    try {
      const response = await axios({
        method: "post",
        url: `${API_URL}/api/User/UpdateWorkTask`,
        headers: {
          "Content-Type": "application/json",
        },
        data: { workid, projectid, workname, supervisorid, workTasks },
      });
      dispatch({
        type: UPDATE_WORK_TASK,
        data: response.data,
      });
      return response.data;
    } catch (error) {
      console.error(error);
    }
  };

export const FetchProjectHiring = (projectid) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/ProjectHiring/FetchProjectHiring`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { projectid },
    });
    dispatch({
      type: PROJECT_HIRING_LIST,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const ProjectHireCreate =
  (
    projectid,
    contacttypeid,
    hiringid,
    startingDate,
    endDate,
    wagerate,
    wageType,
    statusid,
    addtoplanning,
    createdat,
    createdby,
  ) =>
  async (dispatch) => {
    try {
      const response = await axios({
        method: "post",
        url: `${API_URL}/api/ProjectHiring/Create`,
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          projectid,
          contacttypeid,
          hiringid,
          startingDate,
          endDate,
          wagerate,
          wageType,
          statusid,
          addtoplanning,
          createdat,
          createdby,
        },
      });
      dispatch({
        type: PROJECT_HIRE_CREATE,
        data: response.data,
      });
      return response.data;
    } catch (error) {
      console.error(error);
    }
  };

export const ProjectHireUpdate =
  (
    projecthiringid,
    projectid,
    contacttypeid,
    hiringid,
    startingDate,
    endDate,
    wagerate,
    wageType,
    statusid,
    addtoplanning,
    createdat,
    createdby,
  ) =>
  async (dispatch) => {
    try {
      const response = await axios({
        method: "post",
        url: `${API_URL}/api/ProjectHiring/Update`,
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          projecthiringid,
          projectid,
          contacttypeid,
          hiringid,
          startingDate,
          endDate,
          wagerate,
          wageType,
          statusid,
          addtoplanning,
          createdat,
          createdby,
        },
      });
      dispatch({
        type: PROJECT_HIRE_UPDATE,
        data: response.data,
      });
      return response.data;
    } catch (error) {
      console.error(error);
    }
  };

export const ProjectHireDelete = (projecthiringid) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/ProjectHiring/Delete`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { projecthiringid },
    });
    dispatch({
      type: PROJECT_HIRE_DELETE,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const UpdateProjectHiringStatus =
  (projecthiringid, statusId) => async (dispatch) => {
    try {
      const response = await axios({
        method: "post",
        url: `${API_URL}/api/ProjectHiring/UpdateProjectHiringStatus`,
        headers: {
          "Content-Type": "application/json",
        },
        data: { projecthiringid, statusId },
      });
      dispatch({
        type: UPDATE_PROJECT_HIRING_STATUS,
        data: response.data,
      });
      return response.data;
    } catch (error) {
      console.error(error);
    }
  };

export const UpdateProjectHiringExtendPeriod =
  (projecthiringid, startingDate, endDate, addtoplanning) =>
  async (dispatch) => {
    try {
      const response = await axios({
        method: "post",
        url: `${API_URL}/api/ProjectHiring/UpdateProjectHiringExtendPeriod`,
        headers: {
          "Content-Type": "application/json",
        },
        data: { projecthiringid, startingDate, endDate, addtoplanning },
      });
      dispatch({
        type: UPDATE_PROJECT_HIRING_EXTEND_PERIOD,
        data: response.data,
      });
      return response.data;
    } catch (error) {
      console.error(error);
    }
  };

export const DeleteOrder = (orderid) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/DeleteOrder`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { orderid },
    });
    dispatch({
      type: PROJECT_RENT_DELETE,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const UpdateOrderStatus = (orderid, statusid) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/UpdateOrderStatus`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { orderid, statusid },
    });
    dispatch({
      type: UPDATE_PROJECT_RENT_STATUS,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const UpdateRentExpireDate =
  (orderid, rentPeriodTo) => async (dispatch) => {
    try {
      const response = await axios({
        method: "post",
        url: `${API_URL}/api/User/UpdateRentExpireDate`,
        headers: {
          "Content-Type": "application/json",
        },
        data: { orderid, rentPeriodTo },
      });
      dispatch({
        type: UPDATE_PROJECT_RENT_EXTEND_PERIOD,
        data: response.data,
      });
      return response.data;
    } catch (error) {
      console.error(error);
    }
  };

export const AddPhaseMaterials =
  (
    projectid,
    phaseName,
    fileName,
    fileSize,
    unit,
    quantity,
    total,
    isOrderPick,
    materials,
  ) =>
  async (dispatch) => {
    try {
      const response = await axios({
        method: "post",
        url: `${API_URL}/api/User/AddPhaseMaterials`,
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          projectid,
          phaseName,
          fileName,
          fileSize,
          unit,
          quantity,
          total,
          isOrderPick,
          materials,
        },
      });
      dispatch({
        type: ADD_PHASE_MATERIALS,
        data: response.data,
      });
      return response.data;
    } catch (error) {
      console.error(error);
    }
  };

export const FetchPhaseMaterialsByProject = (projectid) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchPhaseMaterialsByProject`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { projectid },
    });
    dispatch({
      type: FETCH_PHASE_MATERIALS_BY_PROJECT,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const FetchPhaseMaterialsById = (phaseId) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchPhaseMaterialsById`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { phaseId },
    });
    dispatch({
      type: FETCH_PHASE_MATERIALS_BY_ID,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const DeletePhase = (phaseid) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/DeletePhase`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { phaseid },
    });
    dispatch({
      type: DELETE_PHASE,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const DeleteMaterials = (material) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/DeleteMaterials`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { material },
    });
    dispatch({
      type: DELETE_MATERIALS,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const AddMaterialList = (materialQuantities) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/AddMaterialList`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { materialQuantities },
    });
    dispatch({
      type: ADD_MATERIAL_LIST,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const FetchMaterialList = (phaseid) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchMaterialList`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { phaseid },
    });
    dispatch({
      type: FETCH_MATERIALS_LIST,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const UpdateMaterialQuantity =
  (materialquantity) => async (dispatch) => {
    try {
      const response = await axios({
        method: "post",
        url: `${API_URL}/api/User/UpdateMaterialQuantity`,
        headers: {
          "Content-Type": "application/json",
        },
        data: { materialquantity },
      });
      dispatch({
        type: UPDATE_MATERIALS_QUANTITY,
        data: response.data,
      });
      return response.data;
    } catch (error) {
      console.error(error);
    }
  };

export const UpdateTaskImage = (taskid, image) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/UpdateTaskImage`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { taskid, image },
    });
    dispatch({
      type: UPDATE_TASK_IMAGE,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const FetchUserTitles = () => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchUserTitles`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {},
    });
    dispatch({
      type: FETCH_USER_TITLE,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const AddUpdateUserTitles =
  (userTitleId, userTitleName) => async (dispatch) => {
    try {
      const response = await axios({
        method: "post",
        url: `${API_URL}/api/User/Add/UpdateUserTitles`,
        headers: {
          "Content-Type": "application/json",
        },
        data: { userTitleId, userTitleName },
      });
      dispatch({
        type: ADD_UPDATE_USER_TITLE,
        data: response.data,
      });
      return response.data;
    } catch (error) {
      console.error(error);
    }
  };

export const DeleteUserTitles = (userTitleId) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/DeleteUserTitles`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { userTitleId },
    });
    dispatch({
      type: DELETE_USER_TITLE,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const FetchProjectByWeeks = () => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchProjectByWeeks`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {},
    });
    dispatch({
      type: FETCH_PROJECTS_BY_WEEKS,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const emptyProductBySupplier = () => (dispatch) => {
  dispatch({ type: "EMPTY_PRODUCT_BY_SUPPLIER", data: {} });
};

export const singleUploadToS3 = (files) => async (dispatch) => {
  let formData = new FormData();
  formData.append("files", files);

  try {
    const response = await axios({
      method: "put",
      url: `${API_URL}/api/Files/UploadToS3`,
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data: formData,
    });
    dispatch({
      type: SINGLE_UPLOAD_TO_S3,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const multipleUploadToS3 = (files, setProgress) => async (dispatch) => {
  let formData = new FormData();

  // formData.append("files", files);
  files?.forEach((item) => {
    formData.append("files", item);
  });

  try {
    const response = await axios({
      method: "put",
      url: `${API_URL}/api/Files/UploadToS3`,
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data: formData,

      // show uploading % 👇
      onUploadProgress: (event) => {
        if (setProgress && event.total) {
          const percent = Math.round((event.loaded * 100) / event.total);
          setProgress(percent);
        }
      },
      // show uploading % 👆
    });
    dispatch({
      type: MULTIPLE_UPLOAD_TO_S3,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: MULTIPLE_UPLOAD_TO_S3,
      data: {
        status: false,
        message:
          error.message ||
          error.response?.data?.message ||
          "Upload failed. Please try again.",
      },
    });
  }
};

export const downloadPDF = (documentid, documentname) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      // url: `${API_URL}/api/Files/UploadToS3`,
      url: `${API_URL}/api/Files/DownloadToS3?documentid=` + documentid,
      responseType: "blob",
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data: {},
    });

    // Trigger file download in browser
    const blob = new Blob([response.data]);
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = documentname;
    document.body.appendChild(link);
    link.click();
    link.remove();

    dispatch({
      type: DOWNLOAD_DOCUMENT,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const storeTimerScreenShots = (screenShotsUrl, screenShotsUrl2) => ({
  type: STORE_TIMER_SCREEN_SHOTS,
  data: {
    screenShotsUrl,
    screenShotsUrl2,
  },
});

export const TimeSessionTimeLine = (sessionId) => async (dispatch) => {
  try {
    const response = await axios({
      method: "get",
      url: `${API_URL}/api/TimeManagement/sessions/${sessionId}/timeline`,
      headers: {
        "Content-Type": "application/json",
      },
      // data: {},
    });
    dispatch({
      type: TIME_MANAGEMENT_SESSION_TIMELINE,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const DeleteScreenShots = (screenshotsId) => async (dispatch) => {
  try {
    const response = await axios({
      method: "delete",
      url: `${API_URL}/api/TimeManagement/screenshots/${screenshotsId}`,
      headers: {
        "Content-Type": "application/json",
      },
      // data: {},
    });
    dispatch({
      type: DELETE_SCREENSHOTS,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const TimeManagementDailySummary =
  (userId, date) => async (dispatch) => {
    try {
      const response = await axios({
        method: "post",
        url: `${API_URL}/api/TimeManagement/daily-summary`,
        headers: {
          "Content-Type": "application/json",
        },
        data: { userId, date },
      });
      dispatch({
        type: TIME_MANAGEMENT_DAILY_SUMMARY,
        data: response.data,
      });
      return response.data;
    } catch (error) {
      console.error(error);
    }
  };

export const AddTranslationData = (data) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/AddTranslationData`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    });
    dispatch({
      type: ADD_TRANSLATION_DATA,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const AddProjectBillingTerms = (name) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/AddProjectBillingTerms`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { name },
    });
    dispatch({
      type: ADD_NEW_PROJECT_BILLING,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const DeleteProjectBillingTerms = (id) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/DeleteProjectBillingTerms`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { id },
    });
    dispatch({
      type: DELETE_NEW_PROJECT_BILLING,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const DeleteUserTimeOff = (userTimeOffid) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/DeleteUserTimeOff`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { userTimeOffid },
    });
    dispatch({
      type: DELETE_USER_TIME_OFF,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const FetchUnits = (type) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchUnits`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { type },
    });
    dispatch({
      type: FECTH_UNITS_PRODUCTS,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const UpdateTemplate = (templateId, isdefault) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/TemplateBuilder/UpdateTemplate`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { templateId, isdefault },
    });
    dispatch({
      type: MAKING_TEMPLATE_DEFAULT,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const FetchDefaultTemplate = () => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/TemplateBuilder/FetchDefaultTemplate`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {},
    });
    dispatch({
      type: FETCH_ISDEFAULT_TEMPLATE,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const filesInsertDocToS3 = (files, setProgress) => async (dispatch) => {
  let formData = new FormData();

  // formData.append("files", files);
  files?.forEach((item) => {
    formData.append("files", item);
  });

  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/Files/InsertDocToS3`,
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data: formData,

      // show uploading % 👇
      onUploadProgress: (event) => {
        if (setProgress && event.total) {
          const percent = Math.round((event.loaded * 100) / event.total);
          setProgress(percent);
        }
      },
      // show uploading % 👆
    });
    dispatch({
      type: FILES_INSERT_DOC_TO_S3,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const AdddocumenttoTask = (taskid, taskdocs) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/Files/AdddocumenttoTask`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { taskid, taskdocs },
    });
    dispatch({
      type: ADD_DOCUMENT_TO_TASK,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const AddTaskForm = (taskid, taskform) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/AddTaskForm`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { taskid, taskform },
    });
    dispatch({
      type: ADD_TASK_FORM,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const UpdateTaskForm = (taskid, taskform) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/UpdateTaskForm`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { taskid, taskform },
    });
    dispatch({
      type: UPDATE_TASK_FORM,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const DeleteTaskForm = (taskFormid) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/DeleteTaskForm`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { taskFormid },
    });
    dispatch({
      type: DELETE_TASK_FORM,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const FetchTaskForm = (taskid) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchTaskForm`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { taskid },
    });
    dispatch({
      type: FETCH_TASK_FORM,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const DeleteAssetBillOfMaterial = (bomId) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/Asset/DeleteAssetBillOfMaterial`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { bomId },
    });
    dispatch({
      type: DELETE_BOM_ITEM,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const DeleteSubSectionParts = (subsectionPartid) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/Asset/DeleteSubSectionParts`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { subsectionPartid },
    });
    dispatch({
      type: DELETE_SUB_SECTION_PARTS,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const DriveAdd = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/SpireAI/drive/add`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: DRIVE_ADD_FOLDER,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const FetchZeroParentFolder = () => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/SpireAI/FetchZeroParentFolder`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {},
    });
    dispatch({
      type: FETCH_ZERO_PARENTS_FOLDER,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const FetchSpireFolderDocuments = (folderId) => async (dispatch) => {
  try {
    const response = await axios({
      method: "get",
      url: `${API_URL}/api/SpireAI/folder/${folderId}`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {},
    });
    dispatch({
      type: FETCH_SPIRE_FOLDER_DOCUMENTS,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const DeleteDriveFolderOrFile = (id, type) => async (dispatch) => {
  try {
    const response = await axios({
      method: "delete",
      url: `${API_URL}/api/SpireAI/drive/delete/${id}/${type}`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {},
    });
    dispatch({
      type: DELETE_DRIVE_FOLDER_OR_FILE,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const AddRootDoc = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/SpireAI/AddRootDoc`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: ADD_DOC_ROOT,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const DriveUpdate = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/SpireAI/drive/update`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: DRIVE_UPDATE_FOLDER,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const fileChunkStart =
  (fileName, fileSize, fileExtension) => async (dispatch) => {
    try {
      const response = await axios({
        method: "post",
        url: `${API_URL}/api/Files/start`,
        headers: {
          "Content-Type": "application/json",
        },
        data: { fileName, fileSize, fileExtension },
      });
      dispatch({
        type: FILE_CHUNK_START,
        data: response.data,
      });
      return response.data;
    } catch (error) {
      console.error(error);
      dispatch({
        type: FILE_CHUNK_START,
        data: error.message,
        // data: {
        //   status: false,
        //   message:
        //     error.message ||
        //     error.response?.data?.message ||
        //     "Upload failed. Please try again.",
        // },
      });
    }
  };

export const filePresign =
  (fileName, uploadId, partNumber) => async (dispatch) => {
    try {
      const response = await axios({
        method: "get",
        url: `${API_URL}/api/Files/presign/${fileName}/${uploadId}/${partNumber}`,
        headers: {
          "Content-Type": "application/json",
        },
        // data: { fileName, uploadId, partNumber },
      });
      dispatch({
        type: FILE_PRESIGN,
        data: response.data,
      });
      return response.data;
    } catch (error) {
      console.error(error);
      dispatch({
        type: FILE_PRESIGN,
        data: error.message,
      });
    }
  };

export const fileChunkComplete = (payload) => async (dispatch) => {
  try {
    const axiosWithoutAuth = axios.create();
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/Files/complete`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: FILE_CHUNK_COMPLETE,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: FILE_CHUNK_COMPLETE,
      data: error.message,
    });
  }
};

export const fileChunkAbort = (fileName, uploadId) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/Files/abort`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { fileName, uploadId },
    });
    dispatch({
      type: FILE_CHUNK_ABORT,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: FILE_CHUNK_ABORT,
      data: error.message,
    });
  }
};

export const FetchFormCertificate = (taskid) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchFormCertificate`,
      headers: {
        "Content-Type": "application/json",
      },
      data: { taskid },
    });
    dispatch({
      type: FETCH_FORM_CERTIFICATES,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: FETCH_FORM_CERTIFICATES,
      data: error.message,
    });
  }
};

export const ajitJsonSpireApi = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      // url: `https://automation.spire.solutions/webhook/webhook/data-push`,
      url: process.env.REACT_APP_SPIRE_AI_DATA_PUSH_API_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: AJIT_SPIRE_API_JSON,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: AJIT_SPIRE_API_JSON,
      data: error.message,
    });
  }
};

export const coWorkerCertification = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/UpdateDeleteCertifications`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: COWORKER_CERTIFICATIONS_ADD_UPDTE_DELETE,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: COWORKER_CERTIFICATIONS_ADD_UPDTE_DELETE,
      data: error.message,
    });
  }
};

export const FetchToDoList = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchToDoList`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: FETCH_TODO_LIST,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: FETCH_TODO_LIST,
      data: error.message,
    });
  }
};

export const UpdateTaskPriority = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/UpdateTaskPriority`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: UPDATE_TASK_PRIORITY,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: UPDATE_TASK_PRIORITY,
      data: error.message,
    });
  }
};

export const UpdateTaskAssigee = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/UpdateTaskAssigee`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: UPDATE_TASK_ASSIGNEE,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: UPDATE_TASK_ASSIGNEE,
      data: error.message,
    });
  }
};

export const UpdateTaskIndex = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/UpdateTaskIndex`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: UPDATE_TASK_INDEX,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: UPDATE_TASK_INDEX,
      data: error.message,
    });
  }
};

export const UpdateChecklistData = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/UpdateChecklistData`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: UPDATE_CHECKLIST_DATA,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: UPDATE_CHECKLIST_DATA,
      data: error.message,
    });
  }
};

export const DeleteProject = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/DeleteProject`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: DELETE_PROJECT,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: DELETE_PROJECT,
      data: error.message,
    });
  }
};

export const UpdateTaskDescription = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/UpdateTaskDescription`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: ADD_TASK_DESCRIPTION,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: ADD_TASK_DESCRIPTION,
      data: error.message,
    });
  }
};

export const FetchBrandHealthApplication = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/Stocks/FetchBrand/Health/Application`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: FETCH_BRAND_HEALTH_APPLICATION,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: FETCH_BRAND_HEALTH_APPLICATION,
      data: error.message,
    });
  }
};

export const SupplierEmailValidation = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/SupplierEmailValidation`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: SUPPLIER_EMAIL_EXIST_OR_NOT,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: SUPPLIER_EMAIL_EXIST_OR_NOT,
      data: error.message,
    });
  }
};

export const ClientNameExistOrNot = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/ClientNameExistOrNot`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: CLIENT_NAME_EXIST_OR_NOT,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: CLIENT_NAME_EXIST_OR_NOT,
      data: error.message,
    });
  }
};

export const RemoveTaskAssigee = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/RemoveTaskAssigee`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: REMOVE_TASK_ASSIGNEE,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: REMOVE_TASK_ASSIGNEE,
      data: error.message,
    });
  }
};

// ASC REDUX PROPS START //
export const assigneeDataLocalAPI = (assigneeData, from) => {
  return {
    type: SET_ASSIGNEE_LOCAL_DATA,
    data: { assigneeData, from },
  };
};
// ASC REDUX PROPS END //

export const productCatalogueApi = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      // url: `${process.env.REACT_APP_AJIT_API_URL}/api/Document`,
      url: `https://automation.spire.solutions/webhook/product-catalogue`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: PRODUCT_CATALOGUE_API,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: PRODUCT_CATALOGUE_API,
      data: error.message,
    });
  }
};

export const FetchProductPartCode = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchProductPartCode`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: FETCH_AUTO_PRODUCT_PART_ITEM_ID,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: FETCH_AUTO_PRODUCT_PART_ITEM_ID,
      data: error.message,
    });
  }
};

export const DuplicateTemplate = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/TemplateBuilder/DuplicateTemplate`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: DUPLICATE_TEMPLATE,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: DUPLICATE_TEMPLATE,
      data: error.message,
    });
  }
};

export const FetchToDoListByProject = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchToDoListByProject`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: FETCH_TODO_LIST_BY_PROJECT,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: FETCH_TODO_LIST_BY_PROJECT,
      data: error.message,
    });
  }
};

export const AdddocumenttoOrder = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/Files/AdddocumenttoOrder`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: ADD_DOCUMENT_TO_ORDER,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: ADD_DOCUMENT_TO_ORDER,
      data: error.message,
    });
  }
};

export const FetchdocumentByOrderid = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/Files/FetchdocumentByOrderid`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: FETCH_DOCUMENT_BY_ORDERID,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: FETCH_DOCUMENT_BY_ORDERID,
      data: error.message,
    });
  }
};

export const FetchProductWithoutSupplier = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchProductWithoutSupplier`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {},
    });
    dispatch({
      type: FETCH_PRODUCT_WITHOUT_SUPPLIER,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: FETCH_PRODUCT_WITHOUT_SUPPLIER,
      data: error.message,
    });
  }
};

export const AddSupplierToProduct = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/AddSupplierToProduct`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: ADD_SUPPLIER_TO_PRODUCT,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: ADD_SUPPLIER_TO_PRODUCT,
      data: error.message,
    });
  }
};

export const SupplierCodeExistOrNot = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/SupplierCodeExistOrNot`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: SUPPLIER_CODE_EXIST_OR_NOT,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: SUPPLIER_CODE_EXIST_OR_NOT,
      data: error.message,
    });
  }
};

export const ProductpartBarCode = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/Stocks/productpart/barcode`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: SUPPLIER_BAR_CODE,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: SUPPLIER_BAR_CODE,
      data: error.message,
    });
  }
};

export const SupplierBarCode = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/Stocks/productpart/barcode`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: SUPPLIER_BAR_CODE,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: SUPPLIER_BAR_CODE,
      data: error.message,
    });
  }
};

export const SupplierBarCodeScan = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/Stocks/productpartsuppliers/barcode/scan`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: SUPPLIER_BAR_CODE_SCAN,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: SUPPLIER_BAR_CODE_SCAN,
      data: error.message,
    });
  }
};

export const SendPurchasingOrderSupplier = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/SendPurchasingOrderSupplier`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: SEND_PO_EMAIL_TO_SUPPLIER,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: SEND_PO_EMAIL_TO_SUPPLIER,
      data: error.message,
    });
  }
};

export const PartDuplicate = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/Stocks/composeproduct/duplicate`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: PART_DUPLICATE,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: PART_DUPLICATE,
      data: error.message,
    });
  }
};

export const UpdateDuplicatePoPartName = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/UpdateProductPartDescription`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: UPDATE_PRODUCT_DESCRIPTION,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: UPDATE_PRODUCT_DESCRIPTION,
      data: error.message,
    });
  }
};

export const AddTaskActivity = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/AddTaskActivity`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: ADD_TASK_ACTIVITY,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: ADD_TASK_ACTIVITY,
      data: error.message,
    });
  }
};

export const UpdateActivity = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/UpdateActivity  `,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: UPDATE_TASK_ACTIVITY,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: UPDATE_TASK_ACTIVITY,
      data: error.message,
    });
  }
};

export const SearchActivity = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/SearchActivity`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: SEARCH_ACTIVITY,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: SEARCH_ACTIVITY,
      data: error.message,
    });
  }
};

export const FetchActivity = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchActivity`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: FETCH_ACTIVITY,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: FETCH_ACTIVITY,
      data: error.message,
    });
  }
};

export const DeleteActivity = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/DeleteActivity`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: DELETE_ACTIVITY,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: DELETE_ACTIVITY,
      data: error.message,
    });
  }
};

export const CreateNewTimeSessionForActivity =
  (payload) => async (dispatch) => {
    try {
      const response = await axios({
        method: "post",
        url: `${API_URL}/api/TimeManagement/CreateNewTimeSessionForActivity`,
        headers: {
          "Content-Type": "application/json",
        },
        data: payload,
      });
      dispatch({
        type: TIMER_FOR_ACTIVITY,
        data: response.data,
      });
      return response.data;
    } catch (error) {
      console.error(error);
      dispatch({
        type: TIMER_FOR_ACTIVITY,
        data: error.message,
      });
    }
  };

export const GetTimeSessionForActivity = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/TimeManagement/GetTimeSessionForActivity`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: GET_TIMER_FOR_ACTIVITY,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: GET_TIMER_FOR_ACTIVITY,
      data: error.message,
    });
  }
};

export const FetchProjectEquipmentActivity = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchProjectEquipmentActivity`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: FETCH_PROJECT_EQUIPMENT_ACTIVITY,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: FETCH_PROJECT_EQUIPMENT_ACTIVITY,
      data: error.message,
    });
  }
};

export const SearchFolderFile = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/SpireAI/SearchFolderFile`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: SEARCH_AI_FOLDER_FILE,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: SEARCH_AI_FOLDER_FILE,
      data: error.message,
    });
  }
};

export const UpdateUserFilter = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/UpdateUserFilter`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: UPDATE_USER_FILTER,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: UPDATE_USER_FILTER,
      data: error.message,
    });
  }
};

export const AddPartEquipments = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/AddPartEquipments`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: ADD_PARTS_EQUIPMENTS,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: ADD_PARTS_EQUIPMENTS,
      data: error.message,
    });
  }
};

export const FetchPartEquipments = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchPartEquipments`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: FETCH_PARTS_EQUIPMENTS,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: FETCH_PARTS_EQUIPMENTS,
      data: error.message,
    });
  }
};

export const UpdatePartEquipments = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/UpdatePartEquipments`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: UPDATE_PARTS_EQUIPMENTS,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: UPDATE_PARTS_EQUIPMENTS,
      data: error.message,
    });
  }
};

export const DeletePartEquipments = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/DeletePartEquipments`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: DELETE_PARTS_EQUIPMENTS,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: DELETE_PARTS_EQUIPMENTS,
      data: error.message,
    });
  }
};

export const UpdateEstimatedTime = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/UpdateEstimatedTime`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: UPDATE_TASK_ESTIMATIONS,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: UPDATE_TASK_ESTIMATIONS,
      data: error.message,
    });
  }
};

export const BuildPOData = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/PerformanceVoucher/BuildPO/task-assignee-data`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: BUILD_PO_DATA,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: BUILD_PO_DATA,
      data: error.message,
    });
  }
};

export const DeletePoResource =
  (performanceVoucherResourceId) => async (dispatch) => {
    try {
      const response = await axios({
        method: "delete",
        url: `${API_URL}/api/PerformanceVoucher/DeletePoResource/${performanceVoucherResourceId}`,
        headers: {
          "Content-Type": "application/json",
        },
        // data: payload,
      });
      dispatch({
        type: DELETE_RESOURCE_PO,
        data: response.data,
      });
      return response.data;
    } catch (error) {
      console.error(error);
      dispatch({
        type: DELETE_RESOURCE_PO,
        data: error.message,
      });
    }
  };

export const logout_session = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/for`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: LOGOUT_SESSION,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: LOGOUT_SESSION,
      data: error.message,
    });
  }
};

export const FetchTaskHistory = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchTaskHistory`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: FETCH_TASK_HISTORY,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: FETCH_TASK_HISTORY,
      data: error.message,
    });
  }
};

export const FetchTaskTimesheet = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchTaskAssigneeTimesheet`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: FETCH_TASK_TIMESHEET,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: FETCH_TASK_TIMESHEET,
      data: error.message,
    });
  }
};

export const AddUpdateTaskDependencies = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/AddUpdateTaskDependencies`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: ADD_UPDATE_TASK_DEPENDENCIES,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: ADD_UPDATE_TASK_DEPENDENCIES,
      data: error.message,
    });
  }
};

export const DeleteTaskDependencies = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/DeleteTaskDependencies`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: DELETE_DEPENDENCIES,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: DELETE_DEPENDENCIES,
      data: error.message,
    });
  }
};

export const AddTaskProductParts = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/AddTaskProductParts`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: ADD_TASK_PRODUCTS_PART,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: ADD_TASK_PRODUCTS_PART,
      data: error.message,
    });
  }
};

export const UpdateTaskProductParts = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/UpdateTaskProductParts`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: UPDATE_TASK_PRODUCTS_PART,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: UPDATE_TASK_PRODUCTS_PART,
      data: error.message,
    });
  }
};

export const FetchTaskProductParts = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchTaskProductParts`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: FETCH_TASK_PRODUCTS_PART,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: FETCH_TASK_PRODUCTS_PART,
      data: error.message,
    });
  }
};

export const DeleteTaskProductParts = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/DeleteTaskProductParts`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: DELETE_TASK_PRODUCTS_PART,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: DELETE_TASK_PRODUCTS_PART,
      data: error.message,
    });
  }
};

export const FetchTaskCostDetails = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchTaskCostDetails`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: FETCH_TASK_COST_DETAILS,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: FETCH_TASK_COST_DETAILS,
      data: error.message,
    });
  }
};

export const CreateInvoice = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/CreateInvoice`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: CREATE_TASK_INVOICE,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: CREATE_TASK_INVOICE,
      data: error.message,
    });
  }
};

export const UpdateSectionIsDefault = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/UpdateSectionIsDefault`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    });
    dispatch({
      type: UPDATE_SECTION_DEFAULT,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: UPDATE_SECTION_DEFAULT,
      data: error.message,
    });
    throw error;
  }
};

export const DeleteComposeProduct = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "delete",
      url: `${API_URL}/api/Stocks/DeleteComposeProduct/${payload.ComposeProductId}`,
      headers: {
        "Content-Type": "application/json",
      },
      // params: payload,
      // data: payload,
    });
    dispatch({
      type: DELETE_COMPOSE_PRODUCT,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: DELETE_COMPOSE_PRODUCT,
      data: error.message,
    });
    throw error;
  }
};

export const UpdateTaskProductPartQtyData = (payload) => async (dispatch) => {
  try {
    const response = await axios({
      method: "post",
      url: `${API_URL}/api/User/UpdateTaskProductPartQtyData`,
      headers: {
        "Content-Type": "application/json",
      },
      // params: payload,
      data: payload,
    });
    dispatch({
      type: UPDATE_TASK_PRODUCT_PART_QTY,
      data: response.data,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    dispatch({
      type: UPDATE_TASK_PRODUCT_PART_QTY,
      data: error.message,
    });
    throw error;
  }
};
